
// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { Box, Button, Checkbox, Card, Typography, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress, Modal, Alert, Snackbar, Tooltip } from "@mui/material";
// import axios from 'axios';
// import config from "../../config.json";
// import AssistantTeamLeadIcon from '../../Images/AssistantTeamLeadIcon.svg';
// import CalenderIcon from '../../Images/CalenderIcon.svg';
// import CurrentSalaryIcon from '../../Images/CurrentSalaryIcon.svg';
// import ExperienceIcon from '../../Images/ExperienceIcon.svg';
// import LocationIcon from '../../Images/LocationIcon.svg';
// import MailIcon from '../../Images/MailIcon.svg';
// import AiGenerateIcon from '../../Images/AiGenerateIcon.svg';
// import SkillSetIcon from '../../Images/SkillSetIcon.svg';
// import ScheduleInterviewPopup from "./ScheduleInterviewPopup";
// import ShortListIcon from '../../Images/ShortListIcon.svg';
// import shortlistedIcon from '../../Images/shortlist.png';
// import rejectlistedIcon from '../../Images/Reject1.png';
// import RejectIcon from '../../Images/RejectIcon.svg';
// import ResumeIcon from '../../Images/ResumeIcon.svg';
// import ShortListPopupIcon from '../../Images/ShortListPopupIcon.svg';
// import RejectPopupIcon from '../../Images/RejectPopupIcon.svg';
// import ShortListPopup from './ShortListPopup';
// import RejectPopup from './RejectPopup';
// import TruncatedTextWithTooltip from '../TruncatedTextWithToolTip';

// const { URL } = config;

// function NewApplication() {
//   const [params, setParams] = useState({ requisitionId: null, email: null });
//   const [renderKey, setRenderKey] = useState(0);
//   const [employeelist, setEmployeelist] = useState([]);
//   const [candidateShareData, setCandidateShareData] = useState(null);
//   const [sender_EmailId, setSender_EmailId] = useState('');
//   const [company_Name, setCompany_Name] = useState('');
//   const [Job_Title, setJob_Title] = useState('');
//   const [Job_Code, setJob_Code] = useState('');
//   const [candidateDetails, setCandidateDetails] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [openBulk, setOpenBulk] = useState(false);
//   const [open1, setOpen1] = useState(false);
//   const [openScheduleLater, setOpenScheduleLater] = useState(false);
//   const [openReject, setOpenReject] = useState(false);
//   const [openSaveButton, setOpenSaveButton] = useState(false);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [selectedItemName, setSelectedItemName] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);
//   const [particularCandidateData, setParticularCandidateData] = useState(null);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [openConfirm, setOpenConfirm] = useState(false);
//   const [actionType, setActionType] = useState('');
//   const [bulkLoading, setBulkLoading] = useState(false);
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');
//   const [open2, setOpen2] = useState(false);

//   const [formData, setFormData] = useState({
//     interviewer: '',
//     interviewTime: '',
//     interviewLocation: '',
//     meetLink: '',
//     candidateEmail: '',
//     interviewerEmail: '',
//     fromDate: '',
//     toDate: '',
//     fromTime: '',
//     toTime: '',
//     interviewType: '',
//     slots: []
//   });

//   const [templates, setTemplates] = useState([]);
//   const [status, setStatus] = useState(false);
//   const [to_email, setTo_Email] = useState(null);
//   const [from_emails, setFrom_Email] = useState(null);

//   useEffect(() => {
//     const extractParams = () => {
//       const queryParams = new URLSearchParams(window.location.search);
//       const requisitionId = queryParams.get('requisitionId');
//       const email = queryParams.get('email');
//       localStorage.setItem('requisitionId', requisitionId);
//       localStorage.setItem('email', email);
//       return { requisitionId, email };
//     };
//     const { requisitionId, email } = extractParams();
//     setParams({ requisitionId, email });
//   }, []);

//   useEffect(() => {
//     getCandidateList(params);
//   }, [params, renderKey]);

//   const getCandidateList = async (params) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const requisitionId = params?.requisitionId || localStorage.getItem('requisitionId');
//       const email = params?.email || localStorage.getItem('email');
//       const response = await axios.get(`${URL}recruitment/candidateShare/${email}/${requisitionId}`);
//       const data = response?.data?.data?.[0];

//       setSender_EmailId(data?.from_email);
//       setTo_Email(data?.from_email);
//       setFrom_Email(email);
//       setCompany_Name(data?.dynamic_template_data?.company_Name);
//       setJob_Title(data?.dynamic_template_data?.jobTitle);
//       setJob_Code(data?.dynamic_template_data?.JobCode);
//       setCandidateShareData(data);

//       localStorage.setItem('senderEmail', data?.from_email);
//       localStorage.setItem('company_Name', data?.dynamic_template_data?.company_Name);
//       localStorage.setItem('JobTitle', data?.dynamic_template_data?.jobTitle);
//       localStorage.setItem('JobCode', data?.dynamic_template_data?.JobCode);

//       const emp = data.data.map((row, index) => ({
//         Skills: row.skills || 'N/A',
//         Language: row.language || 'N/A',
//         FullName: row.full_Name || row.first_Name || 'N/A',
//         FirstName: row.first_Name || 'N/A',
//         EmailId: row.email_Id || 'N/A',
//         MobileNumber: row.mobile_Number || 'N/A',
//         CurrentDesignation: row.current_Designation || 'N/A',
//         CurrentLocation: row.current_Location || 'N/A',
//         NoticePeriod: row.notice_Period || 'N/A',
//         TotalYearsofExperience: row.total_YearsOf_Experience || 'N/A',
//         Resume: data.file_path[index + 1] || null,
//       }));

//       setEmployeelist(emp);
//       fetchCandidateDetails(emp, requisitionId);
//     } catch (error) {
//       console.error('Failed to fetch candidate list:', error);
//       setError('Error loading candidates');
//       setSnackbarMessage('Error loading candidates. Please try again.');
//       setSnackbarSeverity('error');
//       setOpenSnackbar(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchCandidateDetails = async (employeeList, requisitionId) => {
//     try {
//       const formattedEmails = employeeList.map((ele) => decodeURIComponent(ele.EmailId)).join(',');
//       const response = await axios.get(`${URL}employee/candidateByEmail`, {
//         params: { email: formattedEmails, requisitionId },
//       });

//       let details = [];
//       if (Array.isArray(response.data)) {
//         details = response.data;
//       } else if (response.data && Array.isArray(response.data.data)) {
//         details = response.data.data;
//       } else if (response.data && typeof response.data === 'object') {
//         details = Object.values(response.data);
//       } else {
//         console.warn('Unexpected response format for candidate details:', response.data);
//         details = [];
//       }

//       setCandidateDetails(details);
//     } catch (error) {
//       console.error('Error fetching candidate details:', error);
//       setCandidateDetails([]);
//       setSnackbarMessage('Failed to fetch candidate details.');
//       setSnackbarSeverity('error');
//       setOpenSnackbar(true);
//     }
//   };

//   const handleOpen = useCallback((event, elem) => {
//     setParticularCandidateData(elem);
//     setSelectedItemName([elem?.FullName]);
//     setOpen(true);
//   }, []);

//   const handleClose = () => setOpen(false);

//   const handleOpenInBulk = useCallback((items, names) => {
//     setOpenBulk(true);
//   }, []);

//   const handleCloseInBulk = () => setOpenBulk(false);

//   const handleOpen1 = useCallback((event, elem) => {
//     setParticularCandidateData(elem);
//     setSelectedItemName([elem?.FullName]);
//     setOpen1(true);
//   }, []);

//   const handleClose1 = () => setOpen1(false);

//   const handleScheduleLaterOpen = () => {
//     setOpen1(false);
//     setOpenScheduleLater(true);
//     ScheduleInterviewLater1();
//   };

//   useEffect(() => {
//     if (openScheduleLater) {
//       const timer = setTimeout(() => setOpenScheduleLater(false), 1000);
//       return () => clearTimeout(timer);
//     }
//   }, [openScheduleLater]);

//   const handleOpen2 = useCallback((event, elem) => {
//     localStorage.removeItem('EmailId');
//     setParticularCandidateData(elem);
//     setOpenReject(true);
//   }, []);

//   const handleClose2 = () => {
//     setOpenReject(false);
//     setRenderKey((prevKey) => prevKey + 1);
//   };

//   const handleCloseModel = () => setOpenReject(false);

//   const handleSaveButtonOpen = () => {
//     setOpen2(false);
//     setOpenSaveButton(true);
//     setRenderKey((prevKey) => prevKey + 1);
//   };

//   const fetchRequisitionTemplates = async (tempStage, tempSubStage) => {
//     try {
//       const response = await axios.get(`${URL}recruitment/templates_By_RequisitionId`, {
//         params: { requisitionId: params?.requisitionId, stageName: tempStage, subStageName: tempSubStage },
//       });
//       setTemplates(response.data);
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching templates:', error);
//     }
//   };

//   const handleSelectAll = useCallback(() => {
//     const newSelectAll = !selectAll;
//     setSelectAll(newSelectAll);
//     if (newSelectAll) {
//       setSelectedItems(employeelist.map((item) => item.EmailId));
//       setSelectedItemName(employeelist.map((item) => item.FullName));
//     } else {
//       setSelectedItems([]);
//       setSelectedItemName([]);
//     }
//   }, [selectAll, employeelist]);

//   const handleCheckboxChange = useCallback((emailId, fullName) => {
//     setSelectedItems((prev) =>
//       prev.includes(emailId) ? prev.filter((id) => id !== emailId) : [...prev, emailId]
//     );
//     setSelectedItemName((prev) =>
//       prev.includes(fullName) ? prev.filter((name) => name !== fullName) : [...prev, fullName]
//     );
//     setSelectAll((prev) => prev.length + 1 === employeelist.length);
//   }, [employeelist]);

//   const handleBulkActionClick = (event) => setAnchorEl(event.currentTarget);
//   const handleCloseMenu = () => setAnchorEl(null);
//   const handleActionClick = (type) => {
//     setActionType(type);
//     setOpenConfirm(true);
//     handleCloseMenu();
//   };
//   const handleCloseConfirm = () => setOpenConfirm(false);

//   const handleShortListCandidate = useCallback(async () => {
//     try {
//       if (!particularCandidateData?.EmailId || !candidateShareData?.requisitionId) {
//         throw new Error('Missing required candidate or requisition data');
//       }
//       const firstPayload = {
//         email: particularCandidateData.EmailId,
//         requisitionId: candidateShareData.requisitionId
//       };
//       const firstApiResponse = await axios.post(`${URL}employee/getCandidate`, firstPayload);
//       const candidateData = firstApiResponse?.data?.data;
//       if (!candidateData?._id) {
//         throw new Error('Invalid candidate data received');
//       }

//       const [jdResponse, employeeResponse, requisitionResponse] = await Promise.all([
//         axios.get(`${URL}JD_Details/getJD_Details/${candidateShareData.requisitionId}`),
//         axios.get(`${URL}employee/getEmployeeByEmailId`, {
//           params: { email: sender_EmailId }
//         }),
//         axios.get(`${URL}requisition/requisitionBuReqId/${candidateData.requisitionId}`)
//       ]);

//       const jdDetails = jdResponse?.data?.[0];
//       const employeeData = employeeResponse?.data?.data;
//       const requisitionData = requisitionResponse?.data?.[0];

//       const statusData = {
//         Status: "Interview Scheduled",
//         candidateId: candidateData._id,
//         requisitionId: localStorage.getItem("requisitionId") || candidateShareData.requisitionId,
//         message: ""
//       };

//       await axios.put(
//         `${URL}employee/updateCandStatusSingle`,
//         statusData,
//         { headers: { "Content-Type": "application/json" } }
//       );

//       await axios.post(`${URL}recruitment/updateorCreate`, {
//         organisation_id: candidateData.org_id,
//         client_id: candidateData.client_id,
//         candidateId: candidateData._id,
//         requisitionId: candidateShareData.requisitionId,
//         user_email: particularCandidateData.EmailId,
//         stageName: 'submission',
//         stageId: 'stage3',
//         subStages: [{ subStageName: 'Shortlisted By Client' }]
//       });

//       await axios.post(`${URL}recruitmentHistory/history`, {
//         clientId: candidateData.client_id,
//         organizationId: candidateData.org_id,
//         requisitionId: candidateData.requisitionId,
//         candidateId: candidateData._id,
//         actionPerformed: 'Interview Link Sent',
//         actionPerformedBy: {
//           userId: candidateData.addedBy,
//           userName: 'John Doe'
//         }
//       });

//       const parseTime = (timeStr) => {
//         if (!timeStr) return 0;
//         const [hours, minutes] = timeStr.split(':').map(Number);
//         return hours * 60 + minutes;
//       };

//       const interviewDuration = formData.toTime && formData.fromTime
//         ? `${parseTime(formData.toTime) - parseTime(formData.fromTime)} minutes`
//         : 'N/A';

//       const commonTemplateData = {
//         subject: requisitionData?.job_title || 'Job Interview',
//         name: candidateData.first_Name || 'Candidate',
//         Recruiter_Name: `${employeeData?.name || ''} ${employeeData?.l_name || ''}`.trim() || 'Recruiter',
//         Candidate_Name: selectedItemName[0] || candidateData.first_Name,
//         Interview_Date: formData?.fromDate || 'TBD',
//         Interview_Time: formData?.interviewTime || 'TBD',
//         Approximate_Duration: interviewDuration,
//         Mode_Of_Interview: formData?.interviewType || 'N/A',
//         Office_Address: formData?.interviewType === "Virtual"
//           ? formData?.meetLink
//           : formData?.interviewLocation || 'N/A',
//         Hiring_Manager_Name: localStorage.getItem('company_Name') || 'N/A',
//         Name_JobTitle_of_Interviewer: formData?.interviewerEmail || 'N/A',
//         Job_Title: requisitionData?.job_title || 'N/A',
//         user_Email: candidateData.email,
//         requisitionId: candidateData.requisitionId,
//         candidateId: candidateData._id,
//         companyName: requisitionData?.bussiness_unit || 'N/A'
//       };

//       const interviewEmailRequestBody = {
//         to_email: to_email,
//         subject: 'Job Interview Invitation',
//         from_email: "rhutik.p@ipsgroup.co.in",
//         cc: ["rajatsingh7279@gmail.com"],
//         template_id: 'd-221e674882054351917c4f9892a358a9',
//         dynamic_template_data: commonTemplateData,
//         attachment_urls: jdDetails?.EnhancedJd ? [jdDetails.EnhancedJd] : []
//       };

//       const internalEmailRequestBody = {
//         to_email: to_email,
//         subject: 'Job Interview Invitation',
//         cc: ["jasvant.kumar@orgztack.com", "rajatsingh7270@gmail.com"],
//         from_email: "rhutik.p@ipsgroup.co.in",
//         template_id: 'd-334bcf875e7e4214bd9d7cc6ea8dd10d',
//         dynamic_template_data: {
//           ...commonTemplateData,
//           Job_Role: localStorage.getItem('JobTitle') || 'N/A',
//           Sender_Name: `${employeeData?.name || ''} ${employeeData?.l_name || ''}`.trim(),
//           Sender_Job_Title: employeeData?.designation_name || 'No job title'
//         },
//         attachment_urls: jdDetails?.EnhancedJd ? [jdDetails.EnhancedJd] : []
//       };

//       await Promise.all([
//         axios.post('https://us-central1-aitom-b4a1a.cloudfunctions.net/send_email_ips_cc_version1', interviewEmailRequestBody),
//         axios.post('https://us-central1-aitom-b4a1a.cloudfunctions.net/send_email_ips_cc_version1', internalEmailRequestBody)
//       ]);

//       const payload = formData.slots.map(slot => ({
//         company_Name: localStorage.getItem('company_Name'),
//         RequisitionName: localStorage.getItem('JobTitle'),
//         requirementId: localStorage.getItem('JobCode'),
//         interviewer: formData.interviewer,
//         interviewerEmail: formData.interviewerEmail,
//         interviewType: formData.interviewType,
//         meetLink: formData.interviewType === 'Virtual' ? formData.meetLink : undefined,
//         interviewLocation: formData.interviewType === 'In-Person' ? formData.interviewLocation : undefined,
//         fromDate: slot.fromDate,
//         fromTime: slot.fromTime,
//         toTime: slot.toTime,
//         interviewTime: slot.interviewTime,
//         assignedCandidateIds: slot.assignedCandidates?.map(c => c._id) || [],
//         requisitionId: localStorage.getItem('requisitionId') || candidateShareData.requisitionId,
//         orgId: candidateData.org_id,
//         clientId: candidateData.client_id,
//         actionPerformedBy: employeeData?.[0]?.EmpCognitoID || employeeData?.EmpCognitoID,
//         actionPerformedByClientSide: localStorage.getItem('email'),
//         orgId: "kjhbg87yt7",
//         clientId: "kijhgf876jhg87"
//       }));

//       await axios.post(`${URL}recruitment/create`, payload);
//       await axios.post(`${URL}recruitment/createInterviewSlotforCandidateShare`, payload);

//       setSnackbarMessage('Candidate shortlisted and notifications sent successfully!');
//       setSnackbarSeverity('success');
//       setRenderKey(prev => prev + 1);
//       setOpenSnackbar(true);
//       handleClose();
//       handleClose1();
//     } catch (error) {
//       console.error('Error shortlisting candidate:', error);
//       setSnackbarMessage(`Failed to shortlist candidate: ${error.message}`);
//       setSnackbarSeverity('error');
//       setOpenSnackbar(true);
//     }
//   }, [
//     particularCandidateData,
//     candidateShareData,
//     sender_EmailId,
//     formData,
//     selectedItemName,
//     to_email
//   ]);

//   const handleShortListCandidateInBulk = useCallback(async (emailIds, names) => {
//     try {
//       if (!emailIds?.length || !names?.length || !candidateShareData?.requisitionId) {
//         throw new Error('Missing required candidate emails, names, or requisition data');
//       }

//       setBulkLoading(true);

//       const results = await Promise.all(emailIds.map(async (email, index) => {
//         const firstPayload = {
//           email,
//           requisitionId: candidateShareData.requisitionId
//         };
//         const firstApiResponse = await axios.post(`${URL}employee/getCandidate`, firstPayload);
//         const candidateData = firstApiResponse?.data?.data;

//         if (!candidateData?._id) {
//           console.warn(`Invalid candidate data for email: ${email}`);
//           return false;
//         }

//         const [jdResponse, employeeResponse, requisitionResponse] = await Promise.all([
//           axios.get(`${URL}JD_Details/getJD_Details/${candidateShareData.requisitionId}`),
//           axios.get(`${URL}employee/getEmployeeByEmailId`, {
//             params: { email: sender_EmailId }
//           }),
//           axios.get(`${URL}requisition/requisitionBuReqId/${candidateData.requisitionId}`)
//         ]);

//         const jdDetails = jdResponse?.data?.[0];
//         const employeeData = employeeResponse?.data?.data;
//         const requisitionData = requisitionResponse?.data?.[0];

//         const statusData = {
//           Status: "Interview Scheduled",
//           candidateId: candidateData._id,
//           requisitionId: localStorage.getItem("requisitionId") || candidateShareData.requisitionId,
//           message: ""
//         };

//         await axios.put(
//           `${URL}employee/updateCandStatusSingle`,
//           statusData,
//           { headers: { "Content-Type": "application/json" } }
//         );

//         await axios.post(`${URL}recruitment/updateorCreate`, {
//           organisation_id: candidateData.org_id,
//           client_id: candidateData.client_id,
//           candidateId: candidateData._id,
//           requisitionId: candidateShareData.requisitionId,
//           user_email: email,
//           stageName: 'submission',
//           stageId: 'stage3',
//           subStages: [{ subStageName: 'Shortlisted By Client' }]
//         });

//         await axios.post(`${URL}recruitmentHistory/history`, {
//           clientId: candidateData.client_id,
//           organizationId: candidateData.org_id,
//           requisitionId: candidateData.requisitionId,
//           candidateId: candidateData._id,
//           actionPerformed: 'Interview Link Sent',
//           actionPerformedBy: {
//             userId: candidateData.addedBy,
//             userName: 'John Doe'
//           }
//         });

//         const parseTime = (timeStr) => {
//           if (!timeStr) return 0;
//           const [hours, minutes] = timeStr.split(':').map(Number);
//           return hours * 60 + minutes;
//         };

//         const interviewDuration = formData.toTime && formData.fromTime
//           ? `${parseTime(formData.toTime) - parseTime(formData.fromTime)} minutes`
//           : 'N/A';

//         const commonTemplateData = {
//           subject: requisitionData?.job_title || 'Job Interview',
//           name: candidateData.first_Name || 'Candidate',
//           Recruiter_Name: `${employeeData?.name || ''} ${employeeData?.l_name || ''}`.trim() || 'Recruiter',
//           Candidate_Name: names[index] || candidateData.first_Name,
//           Interview_Date: formData?.fromDate || 'TBD',
//           Interview_Time: formData?.interviewTime || 'TBD',
//           Approximate_Duration: interviewDuration,
//           Mode_Of_Interview: formData?.interviewType || 'N/A',
//           Office_Address: formData?.interviewType === "Virtual"
//             ? formData?.meetLink
//             : formData?.interviewLocation || 'N/A',
//           Hiring_Manager_Name: localStorage.getItem('company_Name') || 'N/A',
//           Name_JobTitle_of_Interviewer: formData?.interviewerEmail || 'N/A',
//           Job_Title: requisitionData?.job_title || 'N/A',
//           user_Email: candidateData.email,
//           requisitionId: candidateData.requisitionId,
//           candidateId: candidateData._id,
//           companyName: requisitionData?.bussiness_unit || 'N/A'
//         };

//         const interviewEmailRequestBody = {
//           to_email: to_email,
//           subject: 'Job Interview Invitation',
//           from_email: "rhutik.p@ipsgroup.co.in",
//           cc: ["rajatsingh7279@gmail.com"],
//           template_id: 'd-221e674882054351917c4f9892a358a9',
//           dynamic_template_data: commonTemplateData,
//           attachment_urls: jdDetails?.EnhancedJd ? [jdDetails.EnhancedJd] : []
//         };

//         const internalEmailRequestBody = {
//           to_email: to_email,
//           subject: 'Job Interview Invitation',
//           cc: ["jasvant.kumar@orgztack.com", "rajatsingh7270@gmail.com"],
//           from_email: "rhutik.p@ipsgroup.co.in",
//           template_id: 'd-334bcf875e7e4214bd9d7cc6ea8dd10d',
//           dynamic_template_data: {
//             ...commonTemplateData,
//             Job_Role: localStorage.getItem('JobTitle') || 'N/A',
//             Sender_Name: `${employeeData?.name || ''} ${employeeData?.l_name || ''}`.trim(),
//             Sender_Job_Title: employeeData?.designation_name || 'No job title'
//           },
//           attachment_urls: jdDetails?.EnhancedJd ? [jdDetails.EnhancedJd] : []
//         };

//         await Promise.all([
//           axios.post('https://us-central1-aitom-b4a1a.cloudfunctions.net/send_email_ips_cc_version1', interviewEmailRequestBody),
//           axios.post('https://us-central1-aitom-b4a1a.cloudfunctions.net/send_email_ips_cc_version1', internalEmailRequestBody)
//         ]);

//         const payload = formData.slots.map(slot => ({
//           company_Name: localStorage.getItem('company_Name'),
//           RequisitionName: localStorage.getItem('JobTitle'),
//           requirementId: localStorage.getItem('JobCode'),
//           interviewer: formData.interviewer,
//           interviewerEmail: formData.interviewerEmail,
//           interviewType: formData.interviewType,
//           meetLink: formData.interviewType === 'Virtual' ? formData.meetLink : undefined,
//           interviewLocation: formData.interviewType === 'In-Person' ? formData.interviewLocation : undefined,
//           fromDate: slot.fromDate,
//           fromTime: slot.fromTime,
//           toTime: slot.toTime,
//           interviewTime: slot.interviewTime,
//           assignedCandidateIds: [],
//           requisitionId: localStorage.getItem('requisitionId') || candidateShareData.requisitionId,
//           orgId: candidateData.org_id,
//           clientId: candidateData.client_id,
//           actionPerformedBy: employeeData?.EmpCognitoID || candidateData.addedBy,
//           actionPerformedByClientSide: localStorage.getItem('email'),
//           orgId: "kjhbg87yt7",
//           clientId: "kijhgf876jhg87"
//         }));

//         // await axios.post(`${URL}recruitment/create`, payload);
//         await axios.post(`${URL}recruitment/createInCandiadteShare`, payload);

//         return true;
//       }));

//       if (results.every(result => result)) {
//         setSnackbarMessage('All candidates shortlisted and notifications sent successfully!');
//         setSnackbarSeverity('success');
//         setRenderKey(prevKey => prevKey + 1);
//         setOpenSnackbar(true);
//         handleCloseInBulk();
//       } else {
//         setSnackbarMessage('Some candidates failed to process. Check logs for details.');
//         setSnackbarSeverity('warning');
//         setOpenSnackbar(true);
//       }
//     } catch (error) {
//       console.error('Error in bulk shortlisting:', error);
//       setSnackbarMessage('Failed to process bulk shortlisting: ' + error.message);
//       setSnackbarSeverity('error');
//       setOpenSnackbar(true);
//     } finally {
//       setBulkLoading(false);
//     }
//   }, [candidateShareData, sender_EmailId, formData, to_email]);

//   const ScheduleInterviewLater1 = useCallback(async () => {
//     try {
//       const firstPayload = {
//         email: particularCandidateData.EmailId,
//         requisitionId: candidateShareData.requisitionId,
//       };

//       const firstApiResponse = await axios.post(`${URL}employee/getCandidate`, firstPayload);
//       const candidateData = firstApiResponse?.data?.data;

//       if (!candidateData?._id) {
//         throw new Error('Invalid candidate data received');
//       }

//       await fetchRequisitionTemplates('submission', 'Shortlisted By Client');

//       const statusData = {
//         Status: "Shortlisted",
//         candidateId: candidateData._id,
//         requisitionId: localStorage.getItem("requisitionId"),
//         message: "",
//       };

//       await axios.put(`${URL}employee/updateCandStatusSingle`, statusData, {
//         headers: { "Content-Type": "application/json" },
//       });

//       await axios.post(`${URL}recruitment/updateorCreate`, {
//         organisation_id: candidateData.org_id,
//         client_id: candidateData.client_id,
//         candidateId: candidateData._id,
//         requisitionId: candidateShareData.requisitionId,
//         user_email: particularCandidateData.EmailId,
//         stageName: 'submission',
//         stageId: 'stage3',
//         subStages: [{ subStageName: 'Shortlisted By Client' }],
//       });

//       const historyData = {
//         clientId: candidateData.client_id,
//         organizationId: candidateData.organization_id,
//         requisitionId: candidateData.requisitionId,
//         candidateId: candidateData._id,
//         actionPerformed: 'Interview Link Sent',
//         actionPerformedBy: {
//           userId: candidateData.addedBy,
//           userName: 'John Doe', // Ideally this should be dynamic
//         },
//       };

//       await axios.post(`${URL}recruitmentHistory/history`, historyData);

//       const employeeResponse = await axios.get(
//         `${URL}employee/getEmployeeDetailByEmail/${sender_EmailId}`
//       );

//       const requisitionResponse = await axios.get(
//         `${URL}requisition/requisitionBuReqId/${candidateData.requisitionId}`
//       );

//       const parseTime = (timeStr) => {
//         if (!timeStr) return 0;
//         const [hours, minutes] = timeStr.split(':').map(Number);
//         return hours * 60 + minutes;
//       };

//       const interviewDuration =
//         formData.toTime && formData.fromTime
//           ? `${parseTime(formData.toTime) - parseTime(formData.fromTime)} minutes`
//           : 'N/A';


//           const commonTemplateData = {
//             subject: requisitionResponse?.data?.[0]?.job_title || 'Job Interview',
//             Job_Title:requisitionResponse?.data?.[0]?.job_title || 'N/A',

//             Recruiter_Name: `${employeeResponse?.data?.name || ''} ${employeeResponse?.data?.l_name || ''}`.trim() || 'Recruiter',
//             Candidate_Name: selectedItemName?.[0] || "N/A",

//             Hiring_Manager_Name: localStorage.getItem('company_Name') || 'N/A',

//             // user_Email: candidateData.email,
//             // requisitionId: candidateData.requisitionId,
//             // candidateId: candidateData._id,
//             companyName: localStorage.getItem('company_Name') || 'N/A'
//           };

//           const interviewEmailRequestBody = {
//             to_email: to_email,
//             subject: 'Job Interview Invitation',
//             from_email: "rhutik.p@ipsgroup.co.in",
//             cc: ["rajatsingh7279@gmail.com"],
//             template_id: 'd-221e674882054351917c4f9892a358a9',
//             dynamic_template_data: commonTemplateData,
//             attachment_urls: []
//           };
//       await axios.post('https://us-central1-aitom-b4a1a.cloudfunctions.net/send_email_ips_cc_version1', interviewEmailRequestBody);
//       setSnackbarMessage('Candidate shortlisted!');
//       setSnackbarSeverity('success');
//       setRenderKey((prevKey) => prevKey + 1);
//       setOpenSnackbar(true);
//     } catch (error) {
//       console.error('Error scheduling interview:', error);
//       setSnackbarMessage('Failed to schedule interview.');
//       setSnackbarSeverity('error');
//       setOpenSnackbar(true);
//     }
//   }, [particularCandidateData, candidateShareData, sender_EmailId, formData, selectedItemName]);
//   const handleScheduleinterview = useCallback(async () => {
//     if (!selectedItems.length) {
//       setSnackbarMessage('Please select at least one candidate.');
//       setSnackbarSeverity('warning');
//       setOpenSnackbar(true);
//       return;
//     }
//     setStatus(true);
//     setOpenBulk(true);
//   }, [selectedItems]);

//   const handleConfirmActionIn = useCallback(async (event, actionType) => {
//     setBulkLoading(true);
//     try {
//       const getCandidateDetailsPromises = selectedItems.map((email) =>
//         axios.post(`${URL}employee/getCandidate`, { email, requisitionId: candidateShareData.requisitionId })
//       );
//       const firstApiResponses = await Promise.all(getCandidateDetailsPromises);

//       const statusUpdatePromises = firstApiResponses.map(async (response) => {
//         const candidateData = response?.data?.data;
//         if (!candidateData?._id) {
//           console.warn('Invalid candidate data received:', candidateData);
//           return;
//         }
//         const statusData = {
//           Status: actionType === 'Shortlist' ? 'Shortlisted' : 'Reject',
//           candidateId: candidateData?._id,
//           requisitionId: localStorage.getItem("requisitionId"),
//           message: "",
//         };
//         return await axios.put(
//           `${URL}employee/updateCandStatusSingle`,
//           statusData,
//           { headers: { "Content-Type": "application/json" } }
//         );
//       });
//       await Promise.all(statusUpdatePromises);

//       const postUpdatePromises = firstApiResponses.map((response, index) => {
//         const candidateData = response?.data?.data;
//         if (!candidateData?._id) return Promise.resolve();
//         return axios.post(`${URL}recruitment/updateorCreate`, {
//           organisation_id: candidateData?.org_id,
//           client_id: candidateData?.client_id,
//           candidateId: candidateData?._id,
//           requisitionId: candidateShareData.requisitionId,
//           user_email: selectedItems[index],
//           stageName: 'submission',
//           stageId: 'stage3',
//           subStages: [{ subStageName: actionType === 'Shortlist' ? 'Shortlisted By Client' : 'Rejected by client' }],
//         });
//       });
//       await Promise.all(postUpdatePromises);

//       if (actionType === 'Shortlist') {
//         for (const response of firstApiResponses) {
//           const candidateData = response?.data?.data;
//           if (!candidateData?._id) continue;
//           const jdDetails = await axios.get(`${URL}JD_Details/getJD_Details/${candidateData?.requisitionId}`);
//           const recordsResponse = await axios.get(`${URL}recruitment/recordsByRequisitionId`, {
//             params: { requisitionId: candidateData.requisitionId, candidateId: candidateData._id },
//           });
//           const existingRecord = recordsResponse.data.records?.find(
//             (record) => record.status === 'InterView Link Send' && record.candidateId === candidateData._id
//           );
//           if (existingRecord) {
//             console.log(`Interview invite already sent to ${candidateData._id}`);
//             continue;
//           }

//           const employeeResponse = await axios.get(`${URL}employee/getEmployeeDetailByEmail/${sender_EmailId}`);
//           const requisitionResponse = await axios.get(`${URL}requisition/requisitionBuReqId/${candidateData.requisitionId}`);

//           const parseTime = (timeStr) => {
//             if (!timeStr) return 0;
//             const [hours, minutes] = timeStr.split(':').map(Number);
//             return hours * 60 + minutes;
//           };
//           const interviewDuration = formData.toTime && formData.fromTime
//             ? `${parseTime(formData.toTime) - parseTime(formData.fromTime)} minutes`
//             : 'N/A';

//           const emailRequestBody = {
//             to_email: to_email,
//             subject: 'Job Interview Invitation',
//             from_email: "rhutik.p@ipsgroup.co.in",
//             cc: ["rajatsingh7279@gmail.com"],
//             template_id: 'd-221e674882054351917c4f9892a358a9',
//             dynamic_template_data: {
//               subject: requisitionResponse?.data?.[0]?.job_title,
//               name: candidateData.first_Name,
//               Recruiter_Name: `${employeeResponse?.data?.name || ''} ${employeeResponse?.data?.l_name || ''}`.trim(),
//               Candidate_Name: selectedItemName.join(', '),
//               Interview_Date: formData?.fromDate,
//               Interview_Time: interviewDuration,
//               Approximate_Duration: formData.interviewTime || 'N/A',
//               Mode_Of_Interview: formData.interviewType || 'N/A',
//               Office_Address: formData.interviewLocation || 'N/A',
//               Hiring_Manager_Name: localStorage.getItem('company_Name') || 'N/A',
//               Name_JobTitle_of_Interviewer: formData?.interviewerEmail || 'N/A',
//               Job_Title: requisitionResponse?.data?.[0]?.job_title,
//               user_Email: candidateData.email,
//               requisitionId: candidateData.requisitionId,
//               candidateId: candidateData._id,
//               companyName: requisitionResponse?.data?.[0]?.bussiness_unit,
//             },
//             attachment_urls: [jdDetails?.data?.[0]?.EnhancedJd],
//           };

//           await axios.post('https://us-central1-aitom-b4a1a.cloudfunctions.net/send_email_ips_cc_version1', emailRequestBody);

//           await axios.post(`${URL}recruitmentHistory/history`, {
//             clientId: candidateData.client_id,
//             organizationId: candidateData.organization_id,
//             requisitionId: candidateData.requisitionId,
//             candidateId: candidateData._id,
//             actionPerformed: 'Interview Link Send',
//             actionPerformedBy: { userId: candidateData.addedBy, userName: 'John Doe' },
//           });
//         }
//       }

//       setSnackbarMessage(`${actionType === 'Shortlist' ? 'Shortlisted' : 'Rejected'} candidate(s) successfully!`);
//       setSnackbarSeverity('success');
//       setRenderKey((prevKey) => prevKey + 1);
//       setOpenSnackbar(true);
//     } catch (error) {
//       console.error('Bulk action failed:', error);
//       setSnackbarMessage('Failed to process bulk action.');
//       setSnackbarSeverity('error');
//       setOpenSnackbar(true);
//     } finally {
//       setBulkLoading(false);
//       setOpenConfirm(false);
//     }
//   }, [selectedItems, candidateShareData, sender_EmailId, formData, selectedItemName]);

//   const isShortlisted = useCallback((email) => {
//     if (!Array.isArray(candidateDetails)) {
//       return false;
//     }
//     const candidate = candidateDetails.find((item) => item.email === email);
//     return candidate?.Status?.[0] === 'Shortlisted';
//   }, [candidateDetails]);

//   const isRejected = useCallback((email) => {
//     if (!Array.isArray(candidateDetails)) {
//       return false;
//     }
//     const candidate = candidateDetails.find((item) => item.email === email);
//     return candidate?.Status?.[0] === 'Reject';
//   }, [candidateDetails]);

//   const isInterviewScheduled = useCallback((email) => {
//     if (!Array.isArray(candidateDetails)) {
//       return false;
//     }
//     const candidate = candidateDetails.find((item) => item.email === email);

//     return Array.isArray(candidate?.Status) && candidate.Status.includes('Interview Scheduled');
//   }, [candidateDetails]);

//   const getLimitedSkills = useMemo(() => (skills) => {
//     if (!skills) return 'N/A';
//     const skillArray = skills.split(',').map((s) => s.trim());
//     return skillArray.length > 2 ? `${skillArray.slice(0, 2).join(', ')}...` : skills;
//   }, []);

//   const getLimitedDesignation = useMemo(() => (designation) => {
//     if (!designation) return 'N/A';
//     const designationArray = designation.split(' ').map((d) => d.trim());
//     return designationArray.length > 2 || designation.length > 20
//       ? `${designationArray.slice(0, 2).join(' ')}...`
//       : designation;
//   }, []);

//   const handleButtonClick = (res) => {
//     if (res) {
//       window.open(res, '_blank', 'noopener,noreferrer');
//     } else {
//       setSnackbarMessage('Resume URL not available for this candidate.');
//       setSnackbarSeverity('warning');
//       setOpenSnackbar(true);
//     }
//   };

//   const handleRejectCandidate = useCallback(async () => {
//     try {
//       const firstPayload = {
//         email: particularCandidateData.EmailId,
//         requisitionId: candidateShareData.requisitionId
//       };
//       const firstApiResponse = await axios.post(`${URL}employee/getCandidate`, firstPayload);
//       const candidateData = firstApiResponse?.data?.data;
//       if (!candidateData?._id) {
//         throw new Error('Invalid candidate data received');
//       }

//       const statusData = {
//         Status: "Reject",
//         candidateId: candidateData?._id,
//         requisitionId: localStorage.getItem("requisitionId"),
//         message: "",
//       };
//       await axios.put(
//         `${URL}employee/updateCandStatusSingle`,
//         statusData,
//         { headers: { "Content-Type": "application/json" } }
//       );

//       await axios.post(`${URL}recruitment/updateorCreate`, {
//         organisation_id: candidateData?.org_id,
//         client_id: candidateData?.client_id,
//         candidateId: candidateData?._id,
//         requisitionId: candidateShareData.requisitionId,
//         user_email: particularCandidateData.EmailId,
//         stageName: 'submission',
//         stageId: 'stage3',
//         subStages: [{ subStageName: 'Rejected by client' }],
//       });

//       setSnackbarMessage('Candidate rejected successfully!');
//       setSnackbarSeverity('success');
//       setRenderKey(prevKey => prevKey + 1);
//       setOpenSnackbar(true);
//       handleClose2();
//     } catch (error) {
//       console.error('Error rejecting candidate:', error);
//       setSnackbarMessage('Failed to reject candidate: ' + error.message);
//       setSnackbarSeverity('error');
//       setOpenSnackbar(true);
//     }
//   }, [particularCandidateData, candidateShareData]);

//   if (loading) return <CircularProgress sx={{ display: 'block', mx: 'auto', mt: 4 }} />;
//   if (error) return <Typography color="error" sx={{ textAlign: 'center', mt: 4 }}>{error}</Typography>;
//   if (!employeelist.length) return <Typography sx={{ textAlign: 'center', mt: 4 }}>No candidates found.</Typography>;

//   return (
//     <>
//       <Box sx={{ minHeight: '100vh', bgcolor: '#fff', fontFamily: 'Lexend, sans-serif' }}>
//         <Modal open={openBulk} BackdropProps={{ style: { backgroundColor: 'transparent' } }}>
//           <div>
//             <ScheduleInterviewPopup
//               sender_EmailId={sender_EmailId}
//               open={openBulk} // Pass open prop
//               company_Name={company_Name}
//               Job_Title={Job_Title}
//               Job_Code={Job_Code}
//               selectedItemName={selectedItemName}
//               selectedItems={selectedItems}
//               handleShortListCandidate={handleShortListCandidate}
//               handleShortListCandidateInBulk={handleShortListCandidateInBulk}
//               status={status}
//               formData={formData}
//               setFormData={setFormData}
//               close={handleCloseInBulk}
//             />
//           </div>
//         </Modal>

//         <Box sx={{ position: 'sticky', top: 0, zIndex: 1000, bgcolor: '#fff', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.5)', p: '20px 20px 20px 30px', display: 'flex', alignItems: 'center', gap: '12px' }}>
//           <img src={AiGenerateIcon} style={{ width: '27.53px', height: '27.31px', mr: '3px' }} alt="AI Icon" />
//           <Typography variant="h6" sx={{ fontWeight: 400, fontSize: '24px', lineHeight: '30px', color: '#4D569A' }}>AI-tom</Typography>
//           <Typography variant="body1" sx={{ fontWeight: 400, fontSize: '24px', lineHeight: '30px', color: '#4D569A' }}>
//           > Client - {company_Name} > Select Candidate
//           </Typography>
//         </Box>

//         <Box sx={{ position: 'sticky', top: '60px', zIndex: 900, bgcolor: '#FFF9E9', p: '16px 16px 16px 30px', borderBottom: '1px solid #EBE3D2', boxShadow: '0px -4px 10px rgba(0, 0, 0, 0.3)' }}>
//           <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//             <Typography sx={{ color: '#123DD5', fontSize: '20px', lineHeight: '26.04px', fontWeight: 400 }}>{Job_Title}</Typography>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//               <Button sx={{ bgcolor: '#E1FCDC', borderRadius: '5px', color: '#242424', p: '4px 8px', textTransform: 'none' }}>Active</Button>
//             </Box>
//           </Box>
//         </Box>

//         <Box sx={{ position: 'sticky', top: '120px', zIndex: 800, bgcolor: '#fff', p: '0.5rem 2.5rem', display: 'flex', alignItems: 'center' }}>
//           <Checkbox checked={selectAll} onChange={handleSelectAll} />
//           <Typography sx={{ color: '#242424', fontWeight: 500, fontSize: '12px', lineHeight: '15.62px' }}>Select All</Typography>
//           <Box>
//             <Button sx={{ borderRadius: '5px', border: '1px solid #8098A8', fontSize: '10px', lineHeight: '13.02px', fontWeight: 500, color: '#242424', p: '8px 9px', ml: '15px' }} onClick={handleBulkActionClick}>
//               Bulk Action
//             </Button>
//             <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
//               <MenuItem onClick={() => handleActionClick('Shortlist')}>Shortlist</MenuItem>
//               <MenuItem onClick={() => handleActionClick('Reject')}>Reject</MenuItem>
//               <MenuItem onClick={handleScheduleinterview}>Schedule Interview</MenuItem>
//             </Menu>
//             <Dialog open={openConfirm} onClose={handleCloseConfirm}>
//               <DialogTitle>{actionType === 'Shortlist' ? 'Shortlist Candidates' : 'Reject Candidates'}</DialogTitle>
//               <DialogContent>
//                 <DialogContentText>Are you sure you want to {actionType.toLowerCase()} the selected candidates?</DialogContentText>
//               </DialogContent>
//               <DialogActions>
//                 <Button onClick={handleCloseConfirm} color="secondary">Cancel</Button>
//                 <Button onClick={(event) => handleConfirmActionIn(event, actionType)} color="primary" disabled={bulkLoading}>
//                   {bulkLoading ? <CircularProgress size={20} /> : 'Confirm'}
//                 </Button>
//               </DialogActions>
//             </Dialog>
//           </Box>
//         </Box>

//         <Box sx={{
//           height: 'calc(100vh - 240px)',
//           overflowY: 'auto',
//           px: 3,
//           py: 2,
//           bgcolor: '#F5F7FA',
//           fontFamily: 'Roboto, sans-serif'
//         }}>
//           {employeelist.map((empl, index) => (
//             <Card
//               key={index}
//               sx={{
//                 border: '1px solid #DADCE0',
//                 borderRadius: '8px',
//                 mb: 3,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
//                 bgcolor: '#FFFFFF',
//                 overflow: 'hidden',
//                 transition: 'box-shadow 0.3s ease',
//                 '&:hover': { boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)' }
//               }}
//             >
//               <Box sx={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 bgcolor: '#F8FAFC',
//                 borderBottom: '1px solid #E8ECEF',
//                 p: '16px 24px',
//                 alignItems: 'center'
//               }}>
//                 <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
//                   <Checkbox
//                     checked={selectedItems.includes(empl.EmailId)}
//                     onChange={() => handleCheckboxChange(empl.EmailId, empl.FullName)}
//                     sx={{ '& .MuiSvgIcon-root': { fontSize: 24, color: '#1A73E8' } }}
//                   />
//                   <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                     <Typography sx={{
//                       color: '#1A73E8',
//                       fontSize: '20px',
//                       fontWeight: 500,
//                       lineHeight: '26px',
//                       m: 0
//                     }}>
//                       {empl.FullName || 'N/A'}
//                     </Typography>
//                   </Box>
//                 </Box>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
//                   {isInterviewScheduled(empl?.EmailId) ? (
//                     <Typography sx={{ color: '#0288D1', fontWeight: 500, fontSize: '14px' }}>
//                       Interview Scheduled
//                     </Typography>
//                   ) : isShortlisted(empl?.EmailId) ? (
//                     <Button
//                       variant="contained"
//                       sx={{
//                         bgcolor: '#1A73E8',
//                         color: '#FFFFFF',
//                         fontFamily: 'Roboto, sans-serif',
//                         fontWeight: 500,
//                         fontSize: '14px',
//                         borderRadius: '6px',
//                         height: '36px',
//                         textTransform: 'none',
//                         px: 3,
//                         '&:hover': { bgcolor: '#1557B0' }
//                       }}
//                       onClick={(event) => handleOpen(event, empl)}
//                     >
//                       Schedule Interview
//                     </Button>
//                   ) : null}
//                   <Modal open={open} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' } }}>
//                     <div>
//                       <ScheduleInterviewPopup
//                         sender_EmailId={sender_EmailId}
//                         company_Name={company_Name}
//                         Job_Title={Job_Title}
//                         Job_Code={Job_Code}
//                         selectedItemName={selectedItemName}
//                         handleShortListCandidate={handleShortListCandidate}
//                         formData={formData}
//                         setFormData={setFormData}
//                         close={handleClose}
//                       />
//                     </div>
//                   </Modal>
//                   {!isRejected(empl?.EmailId) && (
//                     !isShortlisted(empl?.EmailId) && !isInterviewScheduled(empl?.EmailId) ? (
//                       <Button
//                         variant="contained"
//                         sx={{
//                           bgcolor: '#34C759',
//                           color: '#FFFFFF',
//                           display: 'flex',
//                           gap: '8px',
//                           fontFamily: 'Roboto, sans-serif',
//                           fontWeight: 500,
//                           fontSize: '14px',
//                           borderRadius: '6px',
//                           height: '36px',
//                           textTransform: 'none',
//                           px: 3,
//                           '&:hover': { bgcolor: '#2E7D32' }
//                         }}
//                         onClick={(event) => handleOpen1(event, empl)}
//                       >
//                         <img src={ShortListIcon} style={{ width: '16px', height: '16px' }} alt="Shortlist" />
//                         Shortlist
//                       </Button>
//                     ) : isShortlisted(empl?.EmailId) && !isInterviewScheduled(empl?.EmailId) ? (
//                       <img src={shortlistedIcon} style={{ width: '85px', height: '27px' }} alt="Shortlisted" />
//                     ) : null
//                   )}
//                   <Modal open={open1} onClose={handleClose1} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' } }}>
//                     <div>
//                       <ShortListPopup
//                         close={handleClose1}
//                         SecondModel={() => setOpen(true)}
//                         formData={formData}
//                         setFormData={setFormData}
//                         handleShortListCandidate={handleShortListCandidate}
//                         // ScheduleInterviewLater1={handleScheduleLaterOpen}
//                         ScheduleInterviewLater1={ScheduleInterviewLater1}
//                         empl={empl}
//                         candidateShareData={candidateShareData}
//                       />
//                     </div>
//                   </Modal>
//                   <Modal open={openScheduleLater} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' } }}>
//                     <Box sx={{
//                       width: '380px',
//                       maxHeight: '220px',
//                       position: 'fixed',
//                       top: '50%',
//                       left: '50%',
//                       transform: 'translate(-50%, -50%)',
//                       borderRadius: '12px',
//                       border: '1px solid #DADCE0',
//                       bgcolor: '#FFFFFF',
//                       boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
//                       p: '24px',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignItems: 'center',
//                       fontFamily: 'Roboto, sans-serif'
//                     }}>
//                       <img src={ShortListPopupIcon} alt="Shortlist Icon" style={{ width: '50px', height: '50px' }} />
//                       <Typography sx={{
//                         textAlign: 'center',
//                         fontSize: '18px',
//                         fontWeight: 500,
//                         lineHeight: '24px',
//                         color: '#202124',
//                         mt: 2
//                       }}>
//                         Candidate Selected!
//                       </Typography>
//                     </Box>
//                   </Modal>
//                   {!isShortlisted(empl?.EmailId) && !isInterviewScheduled(empl?.EmailId) && (
//                     !isRejected(empl?.EmailId) ? (
//                       <Button
//                         variant="contained"
//                         sx={{
//                           bgcolor: '#D93025',
//                           color: '#FFFFFF',
//                           display: 'flex',
//                           gap: '8px',
//                           fontFamily: 'Roboto, sans-serif',
//                           fontWeight: 500,
//                           fontSize: '14px',
//                           borderRadius: '6px',
//                           height: '36px',
//                           textTransform: 'none',
//                           px: 3,
//                           '&:hover': { bgcolor: '#C5221F' }
//                         }}
//                         onClick={(event) => handleOpen2(event, empl)}
//                       >
//                         <img src={RejectIcon} style={{ width: '16px', height: '16px' }} alt="Reject" />
//                         Reject
//                       </Button>
//                     ) : (
//                       <img src={rejectlistedIcon} style={{ width: '110px', height: '40px' }} alt="Rejected" />
//                     )
//                   )}
//                   <Dialog
//                     open={openReject}
//                     onClose={handleClose2}
//                     PaperProps={{
//                       style: {
//                         backgroundColor: 'transparent',
//                         boxShadow: 'none'
//                       }
//                     }}
//                   >
//                     <DialogContent>
//                       <RejectPopup
//                         close={handleClose2}
//                         isRejected={isRejected}
//                         handleClose2={handleClose2}
//                         setOpen2={setOpen2}
//                         params={params}
//                         SaveButton={handleRejectCandidate}
//                         setOpenSaveButton={setOpenSaveButton}
//                         empl={empl}
//                         candidateShareData={candidateShareData}
//                         particularCandidateData={particularCandidateData}
//                         setRenderKey={setRenderKey}
//                         handleCloseModel={handleCloseModel}
//                       />
//                     </DialogContent>
//                   </Dialog>
//                   <Dialog open={openSaveButton} onClose={() => setOpenSaveButton(false)}>
//                     <DialogContent sx={{
//                       width: '380px',
//                       maxHeight: '220px',
//                       borderRadius: '12px',
//                       border: '1px solid #DADCE0',
//                       bgcolor: '#FFFFFF',
//                       boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
//                       p: '24px',
//                       textAlign: 'center',
//                       fontFamily: 'Roboto, sans-serif'
//                     }}>
//                       <img src={RejectPopupIcon} alt="Reject Icon" style={{ width: '50px', height: '50px' }} />
//                       <Typography sx={{
//                         fontSize: '18px',
//                         fontWeight: 500,
//                         lineHeight: '24px',
//                         color: '#202124',
//                         mt: 2
//                       }}>
//                         Candidate Rejected!
//                       </Typography>
//                     </DialogContent>
//                   </Dialog>
//                 </Box>
//               </Box>

//               <Box sx={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 width: '100%',
//                 p: '24px 32px',
//                 gap: '40px',
//                 flexWrap: 'wrap'
//               }}>
//                 <Box sx={{ flex: 1, minWidth: '300px' }}>
//                   <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                     <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }} >
//                       <img src={AssistantTeamLeadIcon} style={{ width: '20px', height: '20px' }} alt="Designation" />
//                       <TruncatedTextWithTooltip style={{
//                         fontFamily: 'DM Sans',
//                         fontWeight: 500,
//                         fontSize: '12px',
//                         lineHeight: '100%',
//                         letterSpacing: '0%'
//                       }} text={empl.CurrentDesignation || "N/A"} width="260px" />
//                     </Box>
//                     <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                         <img src={MailIcon} style={{ width: '20px', height: '20px' }} alt="Email" />
//                         <Tooltip title={empl.EmailId || "N/A"} placement="top">
//                           <Typography sx={{
//                             fontFamily: 'DM Sans',
//                             fontWeight: 500,
//                             fontSize: '12px',
//                             lineHeight: '100%',
//                             letterSpacing: '0%',
//                             color: '#202124',
//                             maxWidth: '260px',
//                             overflow: 'hidden',
//                             textOverflow: 'ellipsis',
//                             whiteSpace: 'nowrap'
//                           }}>
//                             {empl.EmailId}
//                           </Typography>
//                         </Tooltip>
//                       </Box>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                         <img src={LocationIcon} style={{ width: '20px', height: '20px' }} alt="Location" />
//                         <Typography sx={{
//                           fontSize: '14px',
//                           fontWeight: 400,
//                           lineHeight: '20px',
//                           color: '#202124'
//                         }}>
//                           {empl.CurrentLocation || 'N/A'}
//                         </Typography>
//                       </Box>
//                     </Box>
//                     <Button
//                       onClick={() => handleButtonClick(empl.Resume)}
//                       sx={{
//                         borderRadius: '6px',
//                         border: '1px solid #1A73E8',
//                         fontSize: '14px',
//                         fontWeight: 500,
//                         color: '#1A73E8',
//                         p: '8px 16px',
//                         display: 'flex',
//                         gap: '8px',
//                         mt: 2,
//                         textTransform: 'none',
//                         alignSelf: 'flex-start',
//                         '&:hover': { bgcolor: '#E8F0FE' }
//                       }}
//                     >
//                       Resume
//                       <img src={ResumeIcon} style={{ width: '20px', height: '20px' }} alt="Resume" />
//                     </Button>
//                   </Box>
//                 </Box>

//                 <Box sx={{ flex: 1, minWidth: '300px' }}>
//                   <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '8px',
//                         p: 1,
//                         borderRadius: '4px',
//                         '&:hover': empl.Skills ? { bgcolor: '#F1F3F4' } : {}
//                       }}
//                     >
//                       <img src={SkillSetIcon} style={{ width: '20px', height: '20px' }} alt="Skills" />
//                       <Typography sx={{
//                         fontSize: '12px',
//                         fontWeight: 500,
//                         lineHeight: '16px',
//                         color: '#5F6368'
//                       }}>
//                         Skillset:
//                       </Typography>
//                       <Tooltip title={empl.Skills || "N/A"} placement="top">
//                         <Typography sx={{
//                           fontSize: '14px',
//                           fontWeight: 400,
//                           lineHeight: '20px',
//                           color: '#202124',
//                           maxWidth: '260px',
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           whiteSpace: 'nowrap'
//                         }}>
//                           {getLimitedSkills(empl.Skills)}
//                         </Typography>
//                       </Tooltip>
//                     </Box>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                       <img src={ExperienceIcon} style={{ width: '20px', height: '20px' }} alt="Experience" />
//                       <Typography sx={{
//                         fontSize: '12px',
//                         fontWeight: 500,
//                         lineHeight: '16px',
//                         color: '#5F6368'
//                       }}>
//                         Experience:
//                       </Typography>
//                       <Typography sx={{
//                         fontSize: '14px',
//                         fontWeight: 400,
//                         lineHeight: '20px',
//                         color: '#202124'
//                       }}>
//                         {empl.TotalYearsofExperience || 'N/A'}
//                       </Typography>
//                     </Box>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                       <img src={CurrentSalaryIcon} style={{ width: '20px', height: '20px' }} alt="Salary" />
//                       <Typography sx={{
//                         fontSize: '12px',
//                         fontWeight: 500,
//                         lineHeight: '16px',
//                         color: '#5F6368'
//                       }}>
//                         Current Salary:
//                       </Typography>
//                       <Typography sx={{
//                         fontSize: '14px',
//                         fontWeight: 400,
//                         lineHeight: '20px',
//                         color: '#202124'
//                       }}>
//                         {empl.CurrentSalary || 'N/A'}
//                       </Typography>
//                     </Box>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                       <img src={CalenderIcon} style={{ width: '20px', height: '20px' }} alt="Notice Period" />
//                       <Typography sx={{
//                         fontSize: '12px',
//                         fontWeight: 500,
//                         lineHeight: '16px',
//                         color: '#5F6368'
//                       }}>
//                         Notice Period:
//                       </Typography>
//                       <Typography sx={{
//                         fontSize: '14px',
//                         fontWeight: 400,
//                         lineHeight: '20px',
//                         color: '#202124'
//                       }}>
//                         {empl.NoticePeriod || 'N/A'}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Box>
//               </Box>
//             </Card>
//           ))}
//         </Box>

//         <Snackbar open={openSnackbar} autoHideDuration={4000} onClose={() => setOpenSnackbar(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
//           <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>{snackbarMessage}</Alert>
//         </Snackbar>
//       </Box >
//     </>
//   );
// }

// export default NewApplication;
































import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Box, Button, Checkbox, Card, Typography, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress, Modal, Alert, Snackbar, Tooltip } from "@mui/material";
import axios from 'axios';
import config from "../../config.json";
import AssistantTeamLeadIcon from '../../Images/AssistantTeamLeadIcon.svg';
import CalenderIcon from '../../Images/CalenderIcon.svg';
import CurrentSalaryIcon from '../../Images/CurrentSalaryIcon.svg';
import ExperienceIcon from '../../Images/ExperienceIcon.svg';
import LocationIcon from '../../Images/LocationIcon.svg';
import MailIcon from '../../Images/MailIcon.svg';
import AiGenerateIcon from '../../Images/AiGenerateIcon.svg';
import SkillSetIcon from '../../Images/SkillSetIcon.svg';
import ScheduleInterviewPopup from "./ScheduleInterviewPopup";
import ShortListIcon from '../../Images/ShortListIcon.svg';
import shortlistedIcon from '../../Images/shortlist.png';
import rejectlistedIcon from '../../Images/Reject1.png';
import RejectIcon from '../../Images/RejectIcon.svg';
import ResumeIcon from '../../Images/ResumeIcon.svg';
import ShortListPopup from './ShortListPopup';
import RejectPopup from './RejectPopup';
import TruncatedTextWithTooltip from '../TruncatedTextWithToolTip';
import ShortListPopupIcon from '../../Images/ShortListPopupIcon.svg';
import RejectPopupIcon from '../../Images/RejectPopupIcon.svg';

const { URL } = config;

function NewApplication() {
  const [params, setParams] = useState({ requisitionId: null, email: null });
  const [renderKey, setRenderKey] = useState(0);
  const [employeelist, setEmployeelist] = useState([]);
  const [candidateShareData, setCandidateShareData] = useState(null);
  const [sender_EmailId, setSender_EmailId] = useState('');
  const [company_Name, setCompany_Name] = useState('');
  const [Job_Title, setJob_Title] = useState('');
  const [Job_Code, setJob_Code] = useState('');
  const [candidateDetails, setCandidateDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [openBulk, setOpenBulk] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [openScheduleLater, setOpenScheduleLater] = useState(false);
  const [openReject, setOpenReject] = useState(false);
  const [openSaveButton, setOpenSaveButton] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemName, setSelectedItemName] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [particularCandidateData, setParticularCandidateData] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [actionType, setActionType] = useState('');
  const [bulkLoading, setBulkLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [open2, setOpen2] = useState(false);

  const [formData, setFormData] = useState({
    interviewer: '',
    interviewTime: '',
    interviewLocation: '',
    meetLink: '',
    candidateEmail: '',
    interviewerEmail: '',
    fromDate: '',
    toDate: '',
    fromTime: '',
    toTime: '',
    interviewType: '',
    slots: []
  });

  const [templates, setTemplates] = useState([]);
  const [status, setStatus] = useState(false);
  const [to_email, setTo_Email] = useState(null);
  const [from_emails, setFrom_Email] = useState(null);

  useEffect(() => {
    const extractParams = () => {
      const queryParams = new URLSearchParams(window.location.search);
      const requisitionId = queryParams.get('requisitionId');
      const email = queryParams.get('email');
      localStorage.setItem('requisitionId', requisitionId);
      localStorage.setItem('email', email);
      return { requisitionId, email };
    };
    const { requisitionId, email } = extractParams();
    setParams({ requisitionId, email });
  }, []);

  useEffect(() => {
    getCandidateList(params);
  }, [params, renderKey]);

  const getCandidateList = async (params) => {
    setLoading(true);
    setError(null);
    try {
      const requisitionId = params?.requisitionId || localStorage.getItem('requisitionId');
      const email = params?.email || localStorage.getItem('email');
      const response = await axios.get(`${URL}recruitment/candidateShare/${email}/${requisitionId}`);
      const data = response?.data?.data?.[0];

      setSender_EmailId(data?.from_email);
      setTo_Email(data?.from_email);
      setFrom_Email(email);
      setCompany_Name(data?.dynamic_template_data?.company_Name);
      setJob_Title(data?.dynamic_template_data?.jobTitle);
      setJob_Code(data?.dynamic_template_data?.JobCode);
      setCandidateShareData(data);

      localStorage.setItem('senderEmail', data?.from_email);
      localStorage.setItem('company_Name', data?.dynamic_template_data?.company_Name);
      localStorage.setItem('JobTitle', data?.dynamic_template_data?.jobTitle);
      localStorage.setItem('JobCode', data?.dynamic_template_data?.JobCode);

      const emp = data.data.map((row, index) => ({
        Skills: row.skills || 'N/A',
        Language: row.language || 'N/A',
        FullName: row.full_Name || row.first_Name || 'N/A',
        FirstName: row.first_Name || 'N/A',
        EmailId: row.email_Id || 'N/A',
        MobileNumber: row.mobile_Number || 'N/A',
        CurrentDesignation: row.current_Designation || 'N/A',
        CurrentLocation: row.current_Location || 'N/A',
        NoticePeriod: row.notice_Period || 'N/A',
        TotalYearsofExperience: row.total_YearsOf_Experience || 'N/A',
        Resume: data.file_path[index + 1] || null,
      }));

      setEmployeelist(emp);
      fetchCandidateDetails(emp, requisitionId);
    } catch (error) {
      console.error('Failed to fetch candidate list:', error);
      setError('Error loading candidates');
      setSnackbarMessage('Error loading candidates. Please try again.');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchCandidateDetails = async (employeeList, requisitionId) => {
    try {
      const formattedEmails = employeeList.map((ele) => decodeURIComponent(ele.EmailId)).join(',');
      const response = await axios.get(`${URL}employee/candidateByEmail`, {
        params: { email: formattedEmails, requisitionId },
      });

      let details = [];
      if (Array.isArray(response.data)) {
        details = response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        details = response.data.data;
      } else if (response.data && typeof response.data === 'object') {
        details = Object.values(response.data);
      } else {
        console.warn('Unexpected response format for candidate details:', response.data);
        details = [];
      }

      setCandidateDetails(details);
    } catch (error) {
      console.error('Error fetching candidate details:', error);
      setCandidateDetails([]);
      setSnackbarMessage('Failed to fetch candidate details.');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const handleOpen = useCallback((event, elem) => {
    setParticularCandidateData(elem);
    setSelectedItemName([elem?.FullName]);
    setOpen(true);
  }, []);

  const handleClose = () => setOpen(false);

  const handleOpenInBulk = useCallback((items, names) => {
    setOpenBulk(true);
  }, []);

  const handleCloseInBulk = () => setOpenBulk(false);

  const handleOpen1 = useCallback((event, elem) => {
    setParticularCandidateData(elem);
    setSelectedItemName([elem?.FullName]);
    setOpen1(true);
  }, []);

  const handleClose1 = () => setOpen1(false);

  const handleScheduleLaterOpen = () => {
    setOpen1(false);
    setOpenScheduleLater(true);
    ScheduleInterviewLater1();
  };

  useEffect(() => {
    if (openScheduleLater) {
      const timer = setTimeout(() => setOpenScheduleLater(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [openScheduleLater]);

  const handleOpen2 = useCallback((event, elem) => {
    localStorage.removeItem('EmailId');
    setParticularCandidateData(elem);
    setOpenReject(true);
  }, []);

  const handleClose2 = () => {
    setOpenReject(false);
    setRenderKey((prevKey) => prevKey + 1);
  };

  const handleCloseModel = () => setOpenReject(false);

  const handleSaveButtonOpen = () => {
    setOpen2(false);
    setOpenSaveButton(true);
    setRenderKey((prevKey) => prevKey + 1);
  };

  const fetchRequisitionTemplates = async (tempStage, tempSubStage) => {
    try {
      const response = await axios.get(`${URL}recruitment/templates_By_RequisitionId`, {
        params: { requisitionId: params?.requisitionId, stageName: tempStage, subStageName: tempSubStage },
      });
      setTemplates(response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching templates:', error);
    }
  };

  const handleSelectAll = useCallback(() => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    if (newSelectAll) {
      setSelectedItems(employeelist.map((item) => item.EmailId));
      setSelectedItemName(employeelist.map((item) => item.FullName));
    } else {
      setSelectedItems([]);
      setSelectedItemName([]);
    }
  }, [selectAll, employeelist]);

  const handleCheckboxChange = useCallback((emailId, fullName) => {
    setSelectedItems((prev) =>
      prev.includes(emailId) ? prev.filter((id) => id !== emailId) : [...prev, emailId]
    );
    setSelectedItemName((prev) =>
      prev.includes(fullName) ? prev.filter((name) => name !== fullName) : [...prev, fullName]
    );
    setSelectAll((prev) => prev.length + 1 === employeelist.length);
  }, [employeelist]);

  const handleBulkActionClick = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);
  const handleActionClick = (type) => {
    setActionType(type);
    setOpenConfirm(true);
    handleCloseMenu();
  };
  const handleCloseConfirm = () => setOpenConfirm(false);

  const handleShortListCandidate = useCallback(async () => {
    try {

    console.log('check data of formData in 1768', formData)

      if (!particularCandidateData?.EmailId || !candidateShareData?.requisitionId) {
        throw new Error('Missing required candidate or requisition data');
      }
      const firstPayload = {
        email: particularCandidateData.EmailId,
        requisitionId: candidateShareData.requisitionId
      };
      const firstApiResponse = await axios.post(`${URL}employee/getCandidate`, firstPayload);
      const candidateData = firstApiResponse?.data?.data;
      if (!candidateData?._id) {
        throw new Error('Invalid candidate data received');
      }

      const [jdResponse, employeeResponse, requisitionResponse] = await Promise.all([
        axios.get(`${URL}JD_Details/getJD_Details/${candidateShareData.requisitionId}`),
        axios.get(`${URL}employee/getEmployeeByEmailId`, {
          params: { email: sender_EmailId }
        }),
        axios.get(`${URL}requisition/requisitionBuReqId/${candidateData.requisitionId}`)
      ]);

      const jdDetails = jdResponse?.data?.[0];
      const employeeData = employeeResponse?.data?.data;
      const requisitionData = requisitionResponse?.data?.[0];

      const statusData = {
        Status: "Interview Scheduled",
        candidateId: candidateData._id,
        requisitionId: localStorage.getItem("requisitionId") || candidateShareData.requisitionId,
        message: ""
      };

      await axios.put(
        `${URL}employee/updateCandStatusSingle`,
        statusData,
        { headers: { "Content-Type": "application/json" } }
      );

      await axios.post(`${URL}recruitment/updateorCreate`, {
        organisation_id: candidateData.org_id,
        client_id: candidateData.client_id,
        candidateId: candidateData._id,
        requisitionId: candidateShareData.requisitionId,
        user_email: particularCandidateData.EmailId,
        stageName: 'submission',
        stageId: 'stage3',
        subStages: [{ subStageName: 'Shortlisted By Client' }]
      });

      await axios.post(`${URL}recruitmentHistory/history`, {
        clientId: candidateData.client_id,
        organizationId: candidateData.org_id,
        requisitionId: candidateData.requisitionId,
        candidateId: candidateData._id,
        actionPerformed: 'Interview Link Sent',
        actionPerformedBy: {
          userId: candidateData.addedBy,
          userName: 'John Doe'
        }
      });

      const parseTime = (timeStr) => {
        if (!timeStr) return 0;
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours * 60 + minutes;
      };

      // const interviewDuration = formData.toTime && formData.fromTime
      //   ? `${parseTime(formData.toTime) - parseTime(formData.fromTime)} minutes`
      //   : 'N/A';
      const interviewDuration = formData?.slots?.[formData.slots.length - 1]?.fromTime && formData?.slots?.[formData.slots.length - 1]?.toTime
        ? `${Math.abs(parseTime(formData?.slots?.[formData.slots.length - 1]?.fromTime) - parseTime(formData?.slots?.[formData.slots.length - 1]?.toTime))} minutes`
        : 'N/A';

      const commonTemplateData = {
        subject: requisitionData?.job_title || 'Job Interview',
        name: candidateData.first_Name || 'Candidate',
        Recruiter_Name: `${employeeData?.name || ''} ${employeeData?.l_name || ''}`.trim() || 'Recruiter',
        Candidate_Name: selectedItemName[0] || candidateData.first_Name,
        Interview_Date: formData?.slots?.[formData.slots.length - 1]?.fromDate || 'TBD',
        Interview_Time: formData?.slots?.[formData.slots.length - 1]?.interviewTime || 'TBD',
        Approximate_Duration: interviewDuration,
        Mode_Of_Interview: formData?.slots?.[formData.slots.length - 1]?.interviewType || 'N/A',
        Office_Address: formData?.slots?.[formData.slots.length - 1]?.interviewType === "Virtual"
          ? formData?.meetLink
          : formData?.interviewLocation || 'N/A',
        Hiring_Manager_Name: localStorage.getItem('company_Name') || 'N/A',
        Name_JobTitle_of_Interviewer: formData?.interviewerEmail || 'N/A',
        Job_Title: requisitionData?.job_title || 'N/A',
        user_Email: candidateData.email,
        requisitionId: candidateData.requisitionId,
        candidateId: candidateData._id,
        companyName: requisitionData?.bussiness_unit || 'N/A'
      };

      const interviewEmailRequestBody = {
        // to_email: candidateData.email,
        // subject: 'Job Interview Invitation',
        // from_email: "rhutik.p@ipsgroup.co.in",
        to_email: localStorage.getItem('email'),
        from_email: localStorage.getItem('senderEmail'),
        subject: 'Job Interview Invitation',
        cc: ["rajatsingh7279@gmail.com"],
        template_id: 'd-221e674882054351917c4f9892a358a9',
        dynamic_template_data: commonTemplateData,
        attachment_urls: jdDetails?.EnhancedJd ? [jdDetails.EnhancedJd] : []
      };

      const internalEmailRequestBody = {
        to_email: localStorage.getItem('email'),
        from_email: localStorage.getItem('senderEmail'),
        subject: 'Job Interview Invitation',
        template_id: 'd-334bcf875e7e4214bd9d7cc6ea8dd10d',
        dynamic_template_data: {
          ...commonTemplateData,
          Job_Role: localStorage.getItem('JobTitle') || 'N/A',
          Sender_Name: `${employeeData?.name || ''} ${employeeData?.l_name || ''}`.trim(),
          Sender_Job_Title: employeeData?.designation_name || 'No job title'
        },
        attachment_urls: jdDetails?.EnhancedJd ? [jdDetails.EnhancedJd] : []
      };

      await Promise.all([
        axios.post('https://us-central1-aitom-b4a1a.cloudfunctions.net/send_email_ips_cc_version1', interviewEmailRequestBody),
        axios.post('https://us-central1-aitom-b4a1a.cloudfunctions.net/send_email_ips_cc_version1', internalEmailRequestBody)
      ]);

      const payload = formData.slots.map(slot => ({
        company_Name: localStorage.getItem('company_Name'),
        RequisitionName: localStorage.getItem('JobTitle'),
        requirementId: localStorage.getItem('JobCode'),
        interviewer: formData.interviewer,
        interviewerEmail: formData.interviewerEmail,
        interviewType: formData.interviewType,
        meetLink: formData.interviewType === 'Virtual' ? formData.meetLink : undefined,
        interviewLocation: formData.interviewType === 'In-Person' ? formData.interviewLocation : undefined,
        fromDate: slot.fromDate,
        fromTime: slot.fromTime,
        toTime: slot.toTime,
        interviewTime: slot.interviewTime,
        assignedCandidateIds: slot.assignedCandidates?.map(c => c._id) || [],
        requisitionId: localStorage.getItem('requisitionId') || candidateShareData.requisitionId,
        orgId: candidateData.org_id,
        clientId: candidateData.client_id,
        actionPerformedBy: employeeData?.[0]?.EmpCognitoID || employeeData?.EmpCognitoID,
        actionPerformedByClientSide: localStorage.getItem('email'),
        orgId: "kjhbg87yt7",
        clientId: "kijhgf876jhg87"
      }));

      await axios.post(`${URL}recruitment/create`, payload);
      await axios.post(`${URL}recruitment/createInCandiadteShare`, payload);

      setSnackbarMessage('Candidate shortlisted and notifications sent successfully!');
      setSnackbarSeverity('success');
      setRenderKey(prev => prev + 1);
      setOpenSnackbar(true);
      handleClose();
      handleClose1();
    } catch (error) {
      console.error('Error shortlisting candidate:', error);
      setSnackbarMessage(`Failed to shortlist candidate: ${error.message}`);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  }, [
    particularCandidateData,
    candidateShareData,
    sender_EmailId,
    formData,
    selectedItemName
  ]);

  const handleShortListCandidateInBulk = useCallback(async (emailIds, names) => {

    console.log('check data of formData', formData)
    try {
      if (!emailIds?.length || !names?.length || !candidateShareData?.requisitionId) {
        throw new Error('Missing required candidate emails, names, or requisition data');
      }

      setBulkLoading(true);

      const results = await Promise.all(emailIds.map(async (email, index) => {
        const firstPayload = {
          email,
          requisitionId: candidateShareData.requisitionId
        };
        const firstApiResponse = await axios.post(`${URL}employee/getCandidate`, firstPayload);
        const candidateData = firstApiResponse?.data?.data;

        if (!candidateData?._id) {
          console.warn(`Invalid candidate data for email: ${email}`);
          return false;
        }

        const [jdResponse, employeeResponse, requisitionResponse] = await Promise.all([
          axios.get(`${URL}JD_Details/getJD_Details/${candidateShareData.requisitionId}`),
          axios.get(`${URL}employee/getEmployeeByEmailId`, {
            params: { email: sender_EmailId }
          }),
          axios.get(`${URL}requisition/requisitionBuReqId/${candidateData.requisitionId}`)
        ]);

        const jdDetails = jdResponse?.data?.[0];
        const employeeData = employeeResponse?.data?.data;
        const requisitionData = requisitionResponse?.data?.[0];

        const statusData = {
          Status: "Interview Scheduled",
          candidateId: candidateData._id,
          requisitionId: localStorage.getItem("requisitionId") || candidateShareData.requisitionId,
          message: ""
        };

        await axios.put(
          `${URL}employee/updateCandStatusSingle`,
          statusData,
          { headers: { "Content-Type": "application/json" } }
        );

        await axios.post(`${URL}recruitment/updateorCreate`, {
          organisation_id: candidateData.org_id,
          client_id: candidateData.client_id,
          candidateId: candidateData._id,
          requisitionId: candidateShareData.requisitionId,
          user_email: email,
          stageName: 'submission',
          stageId: 'stage3',
          subStages: [{ subStageName: 'Shortlisted By Client' }]
        });

        await axios.post(`${URL}recruitmentHistory/history`, {
          clientId: candidateData.client_id,
          organizationId: candidateData.org_id,
          requisitionId: candidateData.requisitionId,
          candidateId: candidateData._id,
          actionPerformed: 'Interview Link Sent',
          actionPerformedBy: {
            userId: candidateData.addedBy,
            userName: 'John Doe'
          }
        });

        const parseTime = (timeStr) => {
          if (!timeStr) return 0;
          const [hours, minutes] = timeStr.split(':').map(Number);
          return hours * 60 + minutes;
        };

        const interviewDuration = formData.toTime && formData.fromTime
          ? `${parseTime(formData.toTime) - parseTime(formData.fromTime)} minutes`
          : 'N/A';

        const commonTemplateData = {
          subject: requisitionData?.job_title || 'Job Interview',
          name: candidateData.first_Name || 'Candidate',
          Recruiter_Name: `${employeeData?.name || ''} ${employeeData?.l_name || ''}`.trim() || 'Recruiter',
          Candidate_Name: names[index] || candidateData.first_Name,
          Interview_Date: formData?.fromDate || 'TBD',
          Interview_Time: formData?.interviewTime || 'TBD',
          Approximate_Duration: interviewDuration,
          Mode_Of_Interview: formData?.interviewType || 'N/A',
          Office_Address: formData?.interviewType === "Virtual"
            ? formData?.meetLink
            : formData?.interviewLocation || 'N/A',
          Hiring_Manager_Name: localStorage.getItem('company_Name') || 'N/A',
          Name_JobTitle_of_Interviewer: formData?.interviewerEmail || 'N/A',
          Job_Title: requisitionData?.job_title || 'N/A',
          user_Email: candidateData.email,
          requisitionId: candidateData.requisitionId,
          candidateId: candidateData._id,
          companyName: requisitionData?.bussiness_unit || 'N/A'
        };

        const interviewEmailRequestBody = {
          // to_email: candidateData.email,
          // subject: 'Job Interview Invitation',
          // from_email: "rhutik.p@ipsgroup.co.in",
          // cc: ["rajatsingh7279@gmail.com"],
          to_email: localStorage.getItem('email'),
          from_email: localStorage.getItem('senderEmail'),
          subject: 'Job Interview Invitation',
          template_id: 'd-221e674882054351917c4f9892a358a9',
          dynamic_template_data: commonTemplateData,
          attachment_urls: jdDetails?.EnhancedJd ? [jdDetails.EnhancedJd] : []
        };

        const internalEmailRequestBody = {
          to_email: localStorage.getItem('email'),
          from_email: localStorage.getItem('senderEmail'),
          subject: 'Job Interview Invitation',
          // to_email: candidateData.email,
          // subject: 'Job Interview Invitation',
          // cc: ["jasvant.kumar@orgztack.com", "rajatsingh7270@gmail.com"],
          // from_email: "rhutik.p@ipsgroup.co.in",
          template_id: 'd-334bcf875e7e4214bd9d7cc6ea8dd10d',
          dynamic_template_data: {
            ...commonTemplateData,
            Job_Role: localStorage.getItem('JobTitle') || 'N/A',
            Sender_Name: `${employeeData?.name || ''} ${employeeData?.l_name || ''}`.trim(),
            Sender_Job_Title: employeeData?.designation_name || 'No job title'
          },
          attachment_urls: jdDetails?.EnhancedJd ? [jdDetails.EnhancedJd] : []
        };

        await Promise.all([
          axios.post('https://us-central1-aitom-b4a1a.cloudfunctions.net/send_email_ips_cc_version1', interviewEmailRequestBody),
          axios.post('https://us-central1-aitom-b4a1a.cloudfunctions.net/send_email_ips_cc_version1', internalEmailRequestBody)
        ]);

        const payload = formData.slots.map(slot => ({
          company_Name: localStorage.getItem('company_Name'),
          RequisitionName: localStorage.getItem('JobTitle'),
          requirementId: localStorage.getItem('JobCode'),
          interviewer: formData.interviewer,
          interviewerEmail: formData.interviewerEmail,
          interviewType: formData.interviewType,
          meetLink: formData.interviewType === 'Virtual' ? formData.meetLink : undefined,
          interviewLocation: formData.interviewType === 'In-Person' ? formData.interviewLocation : undefined,
          fromDate: slot.fromDate,
          fromTime: slot.fromTime,
          toTime: slot.toTime,
          interviewTime: slot.interviewTime,
          assignedCandidateIds: [],
          requisitionId: localStorage.getItem('requisitionId') || candidateShareData.requisitionId,
          orgId: candidateData.org_id,
          clientId: candidateData.client_id,
          actionPerformedBy: employeeData?.EmpCognitoID || candidateData.addedBy,
          actionPerformedByClientSide: localStorage.getItem('email'),
          orgId: "kjhbg87yt7",
          clientId: "kijhgf876jhg87"
        }));

        await axios.post(`${URL}recruitment/createInCandiadteShare`, payload);

        return true;
      }));

      if (results.every(result => result)) {
        setSnackbarMessage('All candidates shortlisted and notifications sent successfully!');
        setSnackbarSeverity('success');
        setRenderKey(prevKey => prevKey + 1);
        setOpenSnackbar(true);
        handleCloseInBulk();
      } else {
        setSnackbarMessage('Some candidates failed to process. Check logs for details.');
        setSnackbarSeverity('warning');
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error('Error in bulk shortlisting:', error);
      setSnackbarMessage('Failed to process bulk shortlisting: ' + error.message);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setBulkLoading(false);
    }
  }, [candidateShareData, sender_EmailId, formData]);

  const ScheduleInterviewLater1 = useCallback(async () => {
    try {
      const firstPayload = {
        email: particularCandidateData.EmailId,
        requisitionId: candidateShareData.requisitionId,
      };

      const firstApiResponse = await axios.post(`${URL}employee/getCandidate`, firstPayload);
      const candidateData = firstApiResponse?.data?.data;

      if (!candidateData?._id) {
        throw new Error('Invalid candidate data received');
      }

      await fetchRequisitionTemplates('submission', 'Shortlisted By Client');

      const statusData = {
        Status: "Shortlisted",
        candidateId: candidateData._id,
        requisitionId: localStorage.getItem("requisitionId"),
        message: "",
      };

      await axios.put(`${URL}employee/updateCandStatusSingle`, statusData, {
        headers: { "Content-Type": "application/json" },
      });

      await axios.post(`${URL}recruitment/updateorCreate`, {
        organisation_id: candidateData.org_id,
        client_id: candidateData.client_id,
        candidateId: candidateData._id,
        requisitionId: candidateShareData.requisitionId,
        user_email: particularCandidateData.EmailId,
        stageName: 'submission',
        stageId: 'stage3',
        subStages: [{ subStageName: 'Shortlisted By Client' }],
      });

      const historyData = {
        clientId: candidateData.client_id,
        organizationId: candidateData.organization_id,
        requisitionId: candidateData.requisitionId,
        candidateId: candidateData._id,
        actionPerformed: 'Interview Link Sent',
        actionPerformedBy: {
          userId: candidateData.addedBy,
          userName: 'John Doe',
        },
      };

      await axios.post(`${URL}recruitmentHistory/history`, historyData);

      const employeeResponse = await axios.get(
        `${URL}employee/getEmployeeDetailByEmail/${sender_EmailId}`
      );

      const requisitionResponse = await axios.get(
        `${URL}requisition/requisitionBuReqId/${candidateData.requisitionId}`
      );

      const parseTime = (timeStr) => {
        if (!timeStr) return 0;
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours * 60 + minutes;
      };

      const interviewDuration =
        formData.toTime && formData.fromTime
          ? `${parseTime(formData.toTime) - parseTime(formData.fromTime)} minutes`
          : 'N/A';

      const commonTemplateData = {
        subject: requisitionResponse?.data?.[0]?.job_title || 'Job Interview',
        Job_Title: requisitionResponse?.data?.[0]?.job_title || 'N/A',
        Recruiter_Name: `${employeeResponse?.data?.name || ''} ${employeeResponse?.data?.l_name || ''}`.trim() || 'Recruiter',
        Candidate_Name: selectedItemName?.[0] || "N/A",
        Hiring_Manager_Name: localStorage.getItem('company_Name') || 'N/A',
        companyName: localStorage.getItem('company_Name') || 'N/A'
      };

      const interviewEmailRequestBody = {
        // to_email: candidateData.email,
        // subject: 'Job Interview Invitation',
        // from_email: "rhutik.p@ipsgroup.co.in",
        // cc: ["rajatsingh7279@gmail.com"],

        to_email: localStorage.getItem('email'),
        from_email: localStorage.getItem('senderEmail'),
        subject: 'Job Interview Invitation',
        template_id: 'd-221e674882054351917c4f9892a358a9',
        dynamic_template_data: commonTemplateData,
        attachment_urls: []
      };

      await axios.post('https://us-central1-aitom-b4a1a.cloudfunctions.net/send_email_ips_cc_version1', interviewEmailRequestBody);
      setSnackbarMessage('Candidate shortlisted!');
      setSnackbarSeverity('success');
      setRenderKey((prevKey) => prevKey + 1);
      setOpenSnackbar(true);
    } catch (error) {
      console.error('Error scheduling interview:', error);
      setSnackbarMessage('Failed to schedule interview.');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  }, [particularCandidateData, candidateShareData, sender_EmailId, formData, selectedItemName]);

  const handleScheduleinterview = useCallback(async () => {
    if (!selectedItems.length) {
      setSnackbarMessage('Please select at least one candidate.');
      setSnackbarSeverity('warning');
      setOpenSnackbar(true);
      return;
    }
    setStatus(true);
    setOpenBulk(true);
  }, [selectedItems]);

  const handleConfirmActionIn = useCallback(async (event, actionType) => {
    setBulkLoading(true);
    try {
      const getCandidateDetailsPromises = selectedItems.map((email) =>
        axios.post(`${URL}employee/getCandidate`, { email, requisitionId: candidateShareData.requisitionId })
      );
      const firstApiResponses = await Promise.all(getCandidateDetailsPromises);

      let hasDuplicates = false;
      let duplicateEmails = [];

      const statusUpdatePromises = firstApiResponses.map(async (response) => {
        const candidateData = response?.data?.data;
        if (!candidateData?._id) {
          console.warn('Invalid candidate data received:', candidateData);
          return { success: false, email: response.config.data.email, message: 'Invalid candidate data' };
        }
        const statusData = {
          Status: actionType === 'Shortlist' ? 'Shortlisted' : 'Reject',
          candidateId: candidateData?._id,
          requisitionId: localStorage.getItem("requisitionId"),
          message: "",
        };
        try {
          const statusUpdateResponse = await axios.put(
            `${URL}employee/updateCandStatusSingle`,
            statusData,
            { headers: { "Content-Type": "application/json" } }
          );
          // Check if the API indicates the status already exists
          if (statusUpdateResponse?.data?.success === false && statusUpdateResponse?.data?.message?.includes('already exists')) {
            hasDuplicates = true;
            duplicateEmails.push(candidateData.email);
            return {
              success: false,
              email: candidateData.email,
              message: `Status ${statusData.Status} and requisitionId already exists for this candidate`,
            };
          }
          return {
            success: true,
            email: candidateData.email,
            message: 'Status updated successfully',
          };
        } catch (error) {
          const errorMessage = error.response?.data?.message || error.message;
          if (errorMessage.includes('already exists')) {
            hasDuplicates = true;
            duplicateEmails.push(candidateData.email);
            return {
              success: false,
              email: candidateData.email,
              message: `Status ${statusData.Status} and requisitionId already exists for this candidate`,
            };
          }
          return {
            success: false,
            email: candidateData.email,
            message: errorMessage,
          };
        }
      });
      const statusUpdateResults = await Promise.all(statusUpdatePromises);

      const postUpdatePromises = firstApiResponses.map((response, index) => {
        const candidateData = response?.data?.data;
        if (!candidateData?._id) return Promise.resolve();
        // Skip recruitment update if status update failed due to duplicate
        const statusResult = statusUpdateResults.find((result) => result.email === selectedItems[index]);
        if (statusResult?.message?.includes('already exists')) {
          return Promise.resolve();
        }
        return axios.post(`${URL}recruitment/updateorCreate`, {
          organisation_id: candidateData?.org_id,
          client_id: candidateData?.client_id,
          candidateId: candidateData?._id,
          requisitionId: candidateShareData.requisitionId,
          user_email: selectedItems[index],
          stageName: 'submission',
          stageId: 'stage3',
          subStages: [{ subStageName: actionType === 'Shortlist' ? 'Shortlisted By Client' : 'Rejected by client' }],
        });
      });
      await Promise.all(postUpdatePromises);

      if (actionType === 'Shortlist') {
        for (const response of firstApiResponses) {
          const candidateData = response?.data?.data;
          if (!candidateData?._id) continue;
          // Skip email sending if status update failed due to duplicate
          const statusResult = statusUpdateResults.find((result) => result.email === candidateData.email);
          if (statusResult?.message?.includes('already exists')) {
            continue;
          }

          const jdDetails = await axios.get(`${URL}JD_Details/getJD_Details/${candidateData?.requisitionId}`);
          const recordsResponse = await axios.get(`${URL}recruitment/recordsByRequisitionId`, {
            params: { requisitionId: candidateData.requisitionId, candidateId: candidateData._id },
          });
          const existingRecord = recordsResponse.data.records?.find(
            (record) => record.status === 'InterView Link Send' && record.candidateId === candidateData._id
          );
          if (existingRecord) {
            console.log(`Interview invite already sent to ${candidateData._id}`);
            continue;
          }

          const employeeResponse = await axios.get(`${URL}employee/getEmployeeDetailByEmail/${sender_EmailId}`);
          const requisitionResponse = await axios.get(`${URL}requisition/requisitionBuReqId/${candidateData.requisitionId}`);

          const parseTime = (timeStr) => {
            if (!timeStr) return 0;
            const [hours, minutes] = timeStr.split(':').map(Number);
            return hours * 60 + minutes;
          };
          const interviewDuration = formData.toTime && formData.fromTime
            ? `${parseTime(formData.toTime) - parseTime(formData.fromTime)} minutes`
            : 'N/A';

          const emailRequestBody = {
            // to_email: candidateData.email,
            // subject: 'Job Interview Invitation',
            // from_email: "rhutik.p@ipsgroup.co.in",
            // cc: ["rajatsingh7279@gmail.com"],

            to_email: localStorage.getItem('email'),
            from_email: localStorage.getItem('senderEmail'),
            subject: 'Job Interview Invitation',
            template_id: 'd-221e674882054351917c4f9892a358a9',
            dynamic_template_data: {
              subject: requisitionResponse?.data?.[0]?.job_title,
              name: candidateData.first_Name,
              Recruiter_Name: `${employeeResponse?.data?.name || ''} ${employeeResponse?.data?.l_name || ''}`.trim(),
              Candidate_Name: selectedItemName.join(', '),
              Interview_Date: formData?.fromDate,
              Interview_Time: interviewDuration,
              Approximate_Duration: formData.interviewTime || 'N/A',
              Mode_Of_Interview: formData.interviewType || 'N/A',
              Office_Address: formData.interviewLocation || 'N/A',
              Hiring_Manager_Name: localStorage.getItem('company_Name') || 'N/A',
              Name_JobTitle_of_Interviewer: formData?.interviewerEmail || 'N/A',
              Job_Title: requisitionResponse?.data?.[0]?.job_title,
              user_Email: candidateData.email,
              requisitionId: candidateData.requisitionId,
              candidateId: candidateData._id,
              companyName: requisitionResponse?.data?.[0]?.bussiness_unit,
            },
            attachment_urls: [jdDetails?.data?.[0]?.EnhancedJd],
          };

          await axios.post('https://us-central1-aitom-b4a1a.cloudfunctions.net/send_email_ips_cc_version1', emailRequestBody);

          await axios.post(`${URL}recruitmentHistory/history`, {
            clientId: candidateData.client_id,
            organizationId: candidateData.organization_id,
            requisitionId: candidateData.requisitionId,
            candidateId: candidateData._id,
            actionPerformed: 'Interview Link Send',
            actionPerformedBy: { userId: candidateData.addedBy, userName: 'John Doe' },
          });
        }
      }

      // Set Snackbar message based on duplicate status
      if (hasDuplicates) {
        setSnackbarMessage(`Some candidates (${duplicateEmails.join(', ')}) already have status ${actionType === 'Shortlist' ? 'Shortlisted' : 'Rejected'} for this requisition.`);
        setSnackbarSeverity('warning');
      } else {
        setSnackbarMessage(`${actionType === 'Shortlist' ? 'Shortlisted' : 'Rejected'} candidate(s) successfully!`);
        setSnackbarSeverity('success');
      }
      setRenderKey((prevKey) => prevKey + 1);
      setOpenSnackbar(true);
    } catch (error) {
      console.error('Bulk action failed:', error);
      setSnackbarMessage('Failed to process bulk action: ' + error.message);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setBulkLoading(false);
      setOpenConfirm(false);
    }
  }, [selectedItems, candidateShareData, sender_EmailId, formData, selectedItemName]);

  const isShortlisted = useCallback((email) => {
    if (!Array.isArray(candidateDetails)) {
      return false;
    }
    const candidate = candidateDetails.find((item) => item.email === email);
    return candidate?.Status?.[0] === 'Shortlisted';
  }, [candidateDetails]);

  const isRejected = useCallback((email) => {
    if (!Array.isArray(candidateDetails)) {
      return false;
    }
    const candidate = candidateDetails.find((item) => item.email === email);
    return candidate?.Status?.[0] === 'Reject';
  }, [candidateDetails]);

  const isInterviewScheduled = useCallback((email) => {
    if (!Array.isArray(candidateDetails)) {
      return false;
    }
    const candidate = candidateDetails.find((item) => item.email === email);
    return Array.isArray(candidate?.Status) && candidate.Status.includes('Interview Scheduled');
  }, [candidateDetails]);

  const getLimitedSkills = useMemo(() => (skills) => {
    if (!skills) return 'N/A';
    const skillArray = skills.split(',').map((s) => s.trim());
    return skillArray.length > 2 ? `${skillArray.slice(0, 2).join(', ')}...` : skills;
  }, []);

  const getLimitedDesignation = useMemo(() => (designation) => {
    if (!designation) return 'N/A';
    const designationArray = designation.split(' ').map((d) => d.trim());
    return designationArray.length > 2 || designation.length > 20
      ? `${designationArray.slice(0, 2).join(' ')}...`
      : designation;
  }, []);

  const handleButtonClick = (res) => {
    if (res) {
      window.open(res, '_blank', 'noopener,noreferrer');
    } else {
      setSnackbarMessage('Resume URL not available for this candidate.');
      setSnackbarSeverity('warning');
      setOpenSnackbar(true);
    }
  };

  const handleRejectCandidate = useCallback(async () => {
    try {
      const firstPayload = {
        email: particularCandidateData.EmailId,
        requisitionId: candidateShareData.requisitionId
      };
      const firstApiResponse = await axios.post(`${URL}employee/getCandidate`, firstPayload);
      const candidateData = firstApiResponse?.data?.data;
      if (!candidateData?._id) {
        throw new Error('Invalid candidate data received');
      }

      const statusData = {
        Status: "Reject",
        candidateId: candidateData?._id,
        requisitionId: localStorage.getItem("requisitionId"),
        message: "",
      };
      await axios.put(
        `${URL}employee/updateCandStatusSingle`,
        statusData,
        { headers: { "Content-Type": "application/json" } }
      );

      await axios.post(`${URL}recruitment/updateorCreate`, {
        organisation_id: candidateData?.org_id,
        client_id: candidateData?.client_id,
        candidateId: candidateData?._id,
        requisitionId: candidateShareData.requisitionId,
        user_email: particularCandidateData.EmailId,
        stageName: 'submission',
        stageId: 'stage3',
        subStages: [{ subStageName: 'Rejected by client' }],
      });

      setSnackbarMessage('Candidate rejected successfully!');
      setSnackbarSeverity('success');
      setRenderKey(prevKey => prevKey + 1);
      setOpenSnackbar(true);
      handleClose2();
    } catch (error) {
      console.error('Error rejecting candidate:', error);
      setSnackbarMessage('Failed to reject candidate: ' + error.message);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  }, [particularCandidateData, candidateShareData]);

  if (loading) return <CircularProgress sx={{ display: 'block', mx: 'auto', mt: 4 }} />;
  if (error) return <Typography color="error" sx={{ textAlign: 'center', mt: 4 }}>{error}</Typography>;
  if (!employeelist.length) return <Typography sx={{ textAlign: 'center', mt: 4 }}>No candidates found.</Typography>;

  return (
    <>
      <Box sx={{ minHeight: '100vh', bgcolor: '#fff', fontFamily: 'Lexend, sans-serif' }}>
        <Modal open={openBulk} BackdropProps={{ style: { backgroundColor: 'transparent' } }}>
          <div>
            <ScheduleInterviewPopup
              sender_EmailId={sender_EmailId}
              open={openBulk}
              company_Name={company_Name}
              Job_Title={Job_Title}
              Job_Code={Job_Code}
              selectedItemName={selectedItemName}
              selectedItems={selectedItems}
              handleShortListCandidate={handleShortListCandidate}
              handleShortListCandidateInBulk={handleShortListCandidateInBulk}
              status={status}
              formData={formData}
              setFormData={setFormData}
              close={handleCloseInBulk}
            />
          </div>
        </Modal>

        <Box sx={{ position: 'sticky', top: 0, zIndex: 1000, bgcolor: '#fff', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.5)', p: '20px 20px 20px 30px', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img src={AiGenerateIcon} style={{ width: '27.53px', height: '27.31px', mr: '3px' }} alt="AI Icon" />
          <Typography variant="h6" sx={{ fontWeight: 400, fontSize: '24px', lineHeight: '30px', color: '#4D569A' }}>AI-tom</Typography>
          <Typography variant="body1" sx={{ fontWeight: 400, fontSize: '24px', lineHeight: '30px', color: '#4D569A' }}>
            > Client - {company_Name} > Select Candidate
          </Typography>
        </Box>

        <Box sx={{ position: 'sticky', top: '60px', zIndex: 900, bgcolor: '#FFF9E9', p: '16px 16px 16px 30px', borderBottom: '1px solid #EBE3D2', boxShadow: '0px -4px 10px rgba(0, 0, 0, 0.3)' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ color: '#123DD5', fontSize: '20px', lineHeight: '26.04px', fontWeight: 400 }}>{Job_Title}</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Button sx={{ bgcolor: '#E1FCDC', borderRadius: '5px', color: '#242424', p: '4px 8px', textTransform: 'none' }}>Active</Button>
            </Box>
          </Box>
        </Box>

        <Box sx={{ position: 'sticky', top: '120px', zIndex: 800, bgcolor: '#fff', p: '0.5rem 2.5rem', display: 'flex', alignItems: 'center' }}>
          <Checkbox checked={selectAll} onChange={handleSelectAll} />
          <Typography sx={{ color: '#242424', fontWeight: 500, fontSize: '12px', lineHeight: '15.62px' }}>Select All</Typography>
          <Box>
            <Button sx={{ borderRadius: '5px', border: '1px solid #8098A8', fontSize: '10px', lineHeight: '13.02px', fontWeight: 500, color: '#242424', p: '8px 9px', ml: '15px' }} onClick={handleBulkActionClick}>
              Bulk Action
            </Button>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
              <MenuItem onClick={() => handleActionClick('Shortlist')}>Shortlist</MenuItem>
              <MenuItem onClick={() => handleActionClick('Reject')}>Reject</MenuItem>
              <MenuItem onClick={handleScheduleinterview}>Schedule Interview</MenuItem>
            </Menu>
            <Dialog open={openConfirm} onClose={handleCloseConfirm}>
              <DialogTitle>{actionType === 'Shortlist' ? 'Shortlist Candidates' : 'Reject Candidates'}</DialogTitle>
              <DialogContent>
                <DialogContentText>Are you sure you want to {actionType.toLowerCase()} the selected candidates?</DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseConfirm} color="secondary">Cancel</Button>
                <Button onClick={(event) => handleConfirmActionIn(event, actionType)} color="primary" disabled={bulkLoading}>
                  {bulkLoading ? <CircularProgress size={20} /> : 'Confirm'}
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Box>

        <Box sx={{
          height: 'calc(100vh - 240px)',
          overflowY: 'auto',
          px: 3,
          py: 2,
          bgcolor: '#F5F7FA',
          fontFamily: 'Roboto, sans-serif'
        }}>
          {employeelist.map((empl, index) => (
            <Card
              key={index}
              sx={{
                border: '1px solid #DADCE0',
                borderRadius: '8px',
                mb: 3,
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
                bgcolor: '#FFFFFF',
                overflow: 'hidden',
                transition: 'box-shadow 0.3s ease',
                '&:hover': { boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)' }
              }}
            >
              <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                bgcolor: '#F8FAFC',
                borderBottom: '1px solid #E8ECEF',
                p: '16px 24px',
                alignItems: 'center'
              }}>
                <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                  <Checkbox
                    checked={selectedItems.includes(empl.EmailId)}
                    onChange={() => handleCheckboxChange(empl.EmailId, empl.FullName)}
                    sx={{ '& .MuiSvgIcon-root': { fontSize: 24, color: '#1A73E8' } }}
                  />
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography sx={{
                      color: '#1A73E8',
                      fontSize: '20px',
                      fontWeight: 500,
                      lineHeight: '26px',
                      m: 0
                    }}>
                      {empl.FullName || 'N/A'}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  {isInterviewScheduled(empl?.EmailId) ? (
                    <Typography sx={{ color: '#0288D1', fontWeight: 500, fontSize: '14px' }}>
                      Interview Scheduled
                    </Typography>
                  ) : isShortlisted(empl?.EmailId) ? (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: '#1A73E8',
                        color: '#FFFFFF',
                        fontFamily: 'Roboto, sans-serif',
                        fontWeight: 500,
                        fontSize: '14px',
                        borderRadius: '6px',
                        height: '36px',
                        textTransform: 'none',
                        px: 3,
                        '&:hover': { bgcolor: '#1557B0' }
                      }}
                      onClick={(event) => handleOpen(event, empl)}
                    >
                      Schedule Interview
                    </Button>
                  ) : null}
                  <Modal open={open} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' } }}>
                    <div>
                      <ScheduleInterviewPopup
                        sender_EmailId={sender_EmailId}
                        company_Name={company_Name}
                        Job_Title={Job_Title}
                        Job_Code={Job_Code}
                        selectedItemName={selectedItemName}
                        handleShortListCandidate={handleShortListCandidate}
                        formData={formData}
                        setFormData={setFormData}
                        close={handleClose}
                      />

                    </div>
                  </Modal>
                  {!isRejected(empl?.EmailId) && (
                    !isShortlisted(empl?.EmailId) && !isInterviewScheduled(empl?.EmailId) ? (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: '#34C759',
                          color: '#FFFFFF',
                          display: 'flex',
                          gap: '8px',
                          fontFamily: 'Roboto, sans-serif',
                          fontWeight: 500,
                          fontSize: '14px',
                          borderRadius: '6px',
                          height: '36px',
                          textTransform: 'none',
                          px: 3,
                          '&:hover': { bgcolor: '#2E7D32' }
                        }}
                        onClick={(event) => handleOpen1(event, empl)}
                      >
                        <img src={ShortListIcon} style={{ width: '16px', height: '16px' }} alt="Shortlist" />
                        Shortlist
                      </Button>
                    ) : isShortlisted(empl?.EmailId) && !isInterviewScheduled(empl?.EmailId) ? (
                      <img src={shortlistedIcon} style={{ width: '85px', height: '27px' }} alt="Shortlisted" />
                    ) : null
                  )}
                  <Modal open={open1} onClose={handleClose1} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' } }}>
                    <div>
                      <ShortListPopup
                        close={handleClose1}
                        SecondModel={() => setOpen(true)}
                        formData={formData}
                        setFormData={setFormData}
                        handleShortListCandidate={handleShortListCandidate}
                        ScheduleInterviewLater1={ScheduleInterviewLater1}
                        empl={empl}
                        candidateShareData={candidateShareData}
                      />
                    </div>
                  </Modal>
                  <Modal open={openScheduleLater} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' } }}>
                    <Box sx={{
                      width: '380px',
                      maxHeight: '220px',
                      position: 'fixed',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      borderRadius: '12px',
                      border: '1px solid #DADCE0',
                      bgcolor: '#FFFFFF',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                      p: '24px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      fontFamily: 'Roboto, sans-serif'
                    }}>
                      <img src={ShortListPopupIcon} alt="Shortlist Icon" style={{ width: '50px', height: '50px' }} />
                      <Typography sx={{
                        textAlign: 'center',
                        fontSize: '18px',
                        fontWeight: 500,
                        lineHeight: '24px',
                        color: '#202124',
                        mt: 2
                      }}>
                        Candidate Selected!
                      </Typography>
                    </Box>
                  </Modal>
                  {!isShortlisted(empl?.EmailId) && !isInterviewScheduled(empl?.EmailId) && (
                    !isRejected(empl?.EmailId) ? (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: '#D93025',
                          color: '#FFFFFF',
                          display: 'flex',
                          gap: '8px',
                          fontFamily: 'Roboto, sans-serif',
                          fontWeight: 500,
                          fontSize: '14px',
                          borderRadius: '6px',
                          height: '36px',
                          textTransform: 'none',
                          px: 3,
                          '&:hover': { bgcolor: '#C5221F' }
                        }}
                        onClick={(event) => handleOpen2(event, empl)}
                      >
                        <img src={RejectIcon} style={{ width: '16px', height: '16px' }} alt="Reject" />
                        Reject
                      </Button>
                    ) : (
                      <img src={rejectlistedIcon} style={{ width: '110px', height: '40px' }} alt="Rejected" />
                    )
                  )}
                  <Dialog
                    open={openReject}
                    onClose={handleClose2}
                    PaperProps={{
                      style: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none'
                      }
                    }}
                  >
                    <DialogContent>
                      <RejectPopup
                        close={handleClose2}
                        isRejected={isRejected}
                        handleClose2={handleClose2}
                        setOpen2={setOpen2}
                        params={params}
                        SaveButton={handleRejectCandidate}
                        setOpenSaveButton={setOpenSaveButton}
                        empl={empl}
                        candidateShareData={candidateShareData}
                        particularCandidateData={particularCandidateData}
                        setRenderKey={setRenderKey}
                        handleCloseModel={handleCloseModel}
                      />
                    </DialogContent>
                  </Dialog>
                  <Dialog open={openSaveButton} onClose={() => setOpenSaveButton(false)}>
                    <DialogContent sx={{
                      width: '380px',
                      maxHeight: '220px',
                      borderRadius: '12px',
                      border: '1px solid #DADCE0',
                      bgcolor: '#FFFFFF',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                      p: '24px',
                      textAlign: 'center',
                      fontFamily: 'Roboto, sans-serif'
                    }}>
                      <img src={RejectPopupIcon} alt="Reject Icon" style={{ width: '50px', height: '50px' }} />
                      <Typography sx={{
                        fontSize: '18px',
                        fontWeight: 500,
                        lineHeight: '24px',
                        color: '#202124',
                        mt: 2
                      }}>
                        Candidate Rejected!
                      </Typography>
                    </DialogContent>
                  </Dialog>
                </Box>
              </Box>

              <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                p: '24px 32px',
                gap: '40px',
                flexWrap: 'wrap'
              }}>
                <Box sx={{ flex: 1, minWidth: '300px' }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }} >
                      <img src={AssistantTeamLeadIcon} style={{ width: '20px', height: '20px' }} alt="Designation" />
                      <TruncatedTextWithTooltip style={{
                        fontFamily: 'DM Sans',
                        fontWeight: 500,
                        fontSize: '12px',
                        lineHeight: '100%',
                        letterSpacing: '0%'
                      }} text={empl.CurrentDesignation || "N/A"} width="260px" />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <img src={MailIcon} style={{ width: '20px', height: '20px' }} alt="Email" />
                        <Tooltip title={empl.EmailId || "N/A"} placement="top">
                          <Typography sx={{
                            fontFamily: 'DM Sans',
                            fontWeight: 500,
                            fontSize: '12px',
                            lineHeight: '100%',
                            letterSpacing: '0%',
                            color: '#202124',
                            maxWidth: '260px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}>
                            {empl.EmailId}
                          </Typography>
                        </Tooltip>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <img src={LocationIcon} style={{ width: '20px', height: '20px' }} alt="Location" />
                        <Typography sx={{
                          fontSize: '14px',
                          fontWeight: 400,
                          lineHeight: '20px',
                          color: '#202124'
                        }}>
                          {empl.CurrentLocation || 'N/A'}
                        </Typography>
                      </Box>
                    </Box>
                    <Button
                      onClick={() => handleButtonClick(empl.Resume)}
                      sx={{
                        borderRadius: '6px',
                        border: '1px solid #1A73E8',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#1A73E8',
                        p: '8px 16px',
                        display: 'flex',
                        gap: '8px',
                        mt: 2,
                        textTransform: 'none',
                        alignSelf: 'flex-start',
                        '&:hover': { bgcolor: '#E8F0FE' }
                      }}
                    >
                      Resume
                      <img src={ResumeIcon} style={{ width: '20px', height: '20px' }} alt="Resume" />
                    </Button>
                  </Box>
                </Box>

                <Box sx={{ flex: 1, minWidth: '300px' }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        p: 1,
                        borderRadius: '4px',
                        '&:hover': empl.Skills ? { bgcolor: '#F1F3F4' } : {}
                      }}
                    >
                      <img src={SkillSetIcon} style={{ width: '20px', height: '20px' }} alt="Skills" />
                      <Typography sx={{
                        fontSize: '12px',
                        fontWeight: 500,
                        lineHeight: '16px',
                        color: '#5F6368'
                      }}>
                        Skillset:
                      </Typography>
                      <Tooltip title={empl.Skills || "N/A"} placement="top">
                        <Typography sx={{
                          fontSize: '14px',
                          fontWeight: 400,
                          lineHeight: '20px',
                          color: '#202124',
                          maxWidth: '260px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}>
                          {getLimitedSkills(empl.Skills)}
                        </Typography>
                      </Tooltip>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <img src={ExperienceIcon} style={{ width: '20px', height: '20px' }} alt="Experience" />
                      <Typography sx={{
                        fontSize: '12px',
                        fontWeight: 500,
                        lineHeight: '16px',
                        color: '#5F6368'
                      }}>
                        Experience:
                      </Typography>
                      <Typography sx={{
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '20px',
                        color: '#202124'
                      }}>
                        {empl.TotalYearsofExperience || 'N/A'}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <img src={CurrentSalaryIcon} style={{ width: '20px', height: '20px' }} alt="Salary" />
                      <Typography sx={{
                        fontSize: '12px',
                        fontWeight: 500,
                        lineHeight: '16px',
                        color: '#5F6368'
                      }}>
                        Current Salary:
                      </Typography>
                      <Typography sx={{
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '20px',
                        color: '#202124'
                      }}>
                        {empl.CurrentSalary || 'N/A'}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <img src={CalenderIcon} style={{ width: '20px', height: '20px' }} alt="Notice Period" />
                      <Typography sx={{
                        fontSize: '12px',
                        fontWeight: 500,
                        lineHeight: '16px',
                        color: '#5F6368'
                      }}>
                        Notice Period:
                      </Typography>
                      <Typography sx={{
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '20px',
                        color: '#202124'
                      }}>
                        {empl.NoticePeriod || 'N/A'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Card>
          ))}
        </Box>

        <Snackbar open={openSnackbar} autoHideDuration={4000} onClose={() => setOpenSnackbar(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>{snackbarMessage}</Alert>
        </Snackbar>
      </Box>
    </>
  );
}

export default NewApplication;